(function () {
  'use strict';
  var nativeAlert = window.alert;
  var savedDeliveryFields = [];
  var bypassActive = false;
  var savedProductFormValidation = null;
  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function isRakhiProduct() {
    var productTitle = '';
    var titleNode = document.querySelector(
      'h1.product__title, h1.product-title, [data-product-title], .product-title h1'
    );
    if (titleNode) productTitle = titleNode.textContent || '';
    var source = [
      window.location.pathname || '',
      window.location.href || '',
      document.title || '',
      productTitle
    ].join(' ');
    return /rakhi/i.test(source);
  }
  function isRakhiLocationBypassState() {
    /*
     * IMPORTANT:
     * - Serviceable Rakhi locations keep the normal date/type/slot flow.
     * - Only a Rakhi product can bypass when the entered city/pincode
     *   is unavailable / not matched / cannot resolve to an exact pincode.
     * - Non-Rakhi products NEVER use this bypass.
     */
    if (!isRakhiProduct()) return false;

    var message = document.getElementById('ogInlineMessage');
    var text = normalize(message && message.textContent || '');

    if (isUnavailable()) return true;

    return (
      text.indexOf('please enter the receiver\'s exact 6-digit pincode') > -1 ||
      text.indexOf('please enter or select an exact 6-digit pincode') > -1 ||
      text.indexOf('pincode not found') > -1 ||
      text.indexOf('city not found') > -1 ||
      text.indexOf('location not found') > -1 ||
      text.indexOf('not serviceable') > -1 ||
      text.indexOf('not available for this location') > -1
    );
  }

  function canBypassDeliveryValidation() {
    return isRakhiLocationBypassState();
  }
  function isUnavailable() {
    var input = document.getElementById('ogInlineLocationInput');
    var message = document.getElementById('ogInlineMessage');
    if (!input || !message || !String(input.value || '').trim()) return false;
    var text = normalize(message.textContent || '');
    return (
      text.indexOf('delivery is not available') > -1 ||
      text.indexOf('this product cannot be delivered') > -1
    );
  }
  function getDeliveryFields() {
    var selectors = [
      '#og-delivery-widget input',
      '#og-delivery-widget select',
      '#og-delivery-widget textarea',
      '#ogPropCity',
      '#ogPropPincode',
      '#ogPropDate',
      '#ogPropType',
      '#ogPropSlot',
      '#ogPropChargeSummary',
      '#ogPropHiddenType',
      '#ogPropHiddenCharge',
      '#ogPropHiddenSelected',
      'input[name^="properties[📍 Delivery City]"]',
      'input[name^="properties[Delivery Pincode]"]',
      'input[name^="properties[Select Date]"]',
      'input[name^="properties[Pick Delivery Type]"]',
      'input[name^="properties[Time Slot]"]',
      'input[name^="properties[Delivery Charge]"]',
      'input[name^="properties[_og_delivery_"]'
    ];
    var fields = [];
    var seen = [];
    document.querySelectorAll(selectors.join(',')).forEach(function (field) {
      if (!field || seen.indexOf(field) > -1) return;
      if (field.id === 'ogInlineLocationInput') return;
      seen.push(field);
      fields.push(field);
    });
    return fields;
  }
  function saveField(field) {
    if (savedDeliveryFields.some(function (item) { return item.field === field; })) {
      return;
    }
    savedDeliveryFields.push({
      field: field,
      disabled: !!field.disabled,
      required: !!field.required,
      requiredAttr: field.getAttribute('required'),
      ariaRequired: field.getAttribute('aria-required'),
      dataRequired: field.getAttribute('data-required'),
      className: field.className,
      value: field.value
    });
  }
  var lastRakhiBuyTrigger = null;
  var rakhiBuyRetryCount = 0;

  function findPropertyInput(form, propertyName) {
    if (!form) return null;
    var fullName = 'properties[' + propertyName + ']';
    var found = null;
    form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]').forEach(function (node) {
      if (!found && node.name === fullName) found = node;
    });
    return found;
  }

  function upsertBypassProperty(form, propertyName, value) {
    if (!form) return null;
    var node = findPropertyInput(form, propertyName);
    if (!node) {
      node = document.createElement('input');
      node.type = 'hidden';
      node.name = 'properties[' + propertyName + ']';
      node.setAttribute('data-og-rakhi-bypass-created', 'true');
      form.appendChild(node);
    }
    node.disabled = false;
    node.required = false;
    node.removeAttribute('required');
    node.removeAttribute('aria-required');
    node.removeAttribute('data-required');
    node.value = String(value == null ? '' : value);
    try { node.setCustomValidity(''); } catch (e) {}
    return node;
  }

  function setBypassIdValue(id, value) {
    var node = document.getElementById(id);
    if (!node) return;
    saveField(node);
    node.disabled = false;
    node.required = false;
    node.removeAttribute('required');
    node.removeAttribute('aria-required');
    node.removeAttribute('data-required');
    node.value = String(value == null ? '' : value);
    try { node.setCustomValidity(''); } catch (e) {}
  }

  function primeRakhiBypassProperties() {
    if (!isRakhiProduct()) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var locationInput = document.getElementById('ogInlineLocationInput');
    var rawLocation = String(locationInput && locationInput.value || '').trim();
    var pinMatch = rawLocation.match(/\b\d{6}\b/);
    var enteredPin = pinMatch ? pinMatch[0] : '';

    /*
     * These values exist only to let the existing Buy Now / add-on / GoKwik
     * validation chain continue for an UNMATCHED Rakhi location.
     * We preserve the customer's real entered pincode whenever available.
     */
    var cityValue = rawLocation || 'Rakhi Delivery';
    var pinValue = enteredPin || 'Rakhi';
    var dateValue = 'Rakhi Delivery';
    var typeValue = 'Standard Delivery';
    var slotValue = 'As per availability';

    setBypassIdValue('ogPropCity', cityValue);
    setBypassIdValue('ogPropPincode', pinValue);
    setBypassIdValue('ogPropDate', dateValue);
    setBypassIdValue('ogPropType', typeValue);
    setBypassIdValue('ogPropSlot', slotValue);
    setBypassIdValue('ogPropChargeSummary', '');
    setBypassIdValue('ogPropHiddenType', 'rakhi_bypass');
    setBypassIdValue('ogPropHiddenCharge', '0');
    setBypassIdValue('ogPropHiddenSelected', '1');

    upsertBypassProperty(form, '📍 Delivery City', cityValue);
    upsertBypassProperty(form, 'Delivery Pincode', pinValue);
    upsertBypassProperty(form, 'Select Date', dateValue);
    upsertBypassProperty(form, 'Pick Delivery Type', typeValue);
    upsertBypassProperty(form, 'Time Slot', slotValue);
    upsertBypassProperty(form, 'Delivery Charge', '');
    upsertBypassProperty(form, '_og_delivery_type', 'rakhi_bypass');
    upsertBypassProperty(form, '_og_delivery_total_charge', '0');
    upsertBypassProperty(form, '_og_delivery_selected', '1');
    upsertBypassProperty(form, '_og_rakhi_location_bypass', '1');
  }

  function enableUnavailableBypass() {
    if (!canBypassDeliveryValidation()) return;
    bypassActive = true;

    primeRakhiBypassProperties();

    getDeliveryFields().forEach(function (field) {
      saveField(field);
      field.required = false;
      field.removeAttribute('required');
      field.removeAttribute('aria-required');
      field.removeAttribute('data-required');
      if (field.classList) {
        field.classList.remove(
          'required',
          'is-required',
          'field--required',
          'field-error',
          'field--error',
          'error',
          'invalid',
          'is-invalid'
        );
      }
      try {
        field.setCustomValidity('');
      } catch (e) {}
    });
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      if (!savedProductFormValidation) {
        savedProductFormValidation = {
          form: form,
          hadNoValidateAttr: form.hasAttribute('novalidate'),
          noValidate: !!form.noValidate
        };
      }
      form.setAttribute('novalidate', 'novalidate');
      form.noValidate = true;
    }
    removeRequiredMessage();
  }
  function disableUnavailableBypass() {
    if (!bypassActive) return;
    savedDeliveryFields.forEach(function (item) {
      var field = item.field;
      if (!field || !field.isConnected) return;
      field.disabled = item.disabled;
      field.required = item.required;
      if (item.requiredAttr !== null) {
        field.setAttribute('required', item.requiredAttr);
      } else {
        field.removeAttribute('required');
      }
      if (item.ariaRequired !== null) {
        field.setAttribute('aria-required', item.ariaRequired);
      } else {
        field.removeAttribute('aria-required');
      }
      if (item.dataRequired !== null) {
        field.setAttribute('data-required', item.dataRequired);
      } else {
        field.removeAttribute('data-required');
      }
      field.className = item.className;
      if (Object.prototype.hasOwnProperty.call(item, 'value')) {
        field.value = item.value;
      }
    });

    document.querySelectorAll('[data-og-rakhi-bypass-created="true"]').forEach(function (node) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
    if (savedProductFormValidation) {
      var savedForm = savedProductFormValidation.form;
      if (savedForm && savedForm.isConnected) {
        savedForm.noValidate = savedProductFormValidation.noValidate;
        if (savedProductFormValidation.hadNoValidateAttr) {
          savedForm.setAttribute('novalidate', 'novalidate');
        } else {
          savedForm.removeAttribute('novalidate');
        }
      }
      savedProductFormValidation = null;
    }
    savedDeliveryFields = [];
    bypassActive = false;
  }
  function removeRequiredMessage() {
    var phrases = [
      'please fill this required option',
      'please fill required option',
      'please fill this option'
    ];
    document.querySelectorAll('body *').forEach(function (node) {
      if (!node || node.children.length) return;
      var text = normalize(node.textContent || '');
      if (!text) return;
      if (phrases.some(function (phrase) { return text.indexOf(phrase) > -1; })) {
        var wrapper =
          node.closest('.field-error, .field--error, .error, .errors, [class*="error"]') ||
          node;
        wrapper.style.display = 'none';
        wrapper.setAttribute('data-og-hidden-required-error', 'true');
      }
    });
  }
  function isBuyTrigger(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      'button[type="submit"], input[type="submit"], button[name="add"], ' +
      '.shopify-payment-button__button, [data-buy-now], [data-add-to-cart], ' +
      'a[class*="buy"], div[class*="buy-now"]'
    );
  }
  function isRakhiBuyNowTrigger(target) {
    if (!target || !target.closest) return null;

    var explicitTrigger = target.closest(
      '.shopify-payment-button__button, [data-buy-now], [data-og-buy-now], ' +
      '.buy-now, .buy-now-button, button[class*="buy-now"], a[class*="buy-now"], ' +
      '[class*="buy_now"], [id*="buy-now"], [id*="buy_now"]'
    );
    if (explicitTrigger) return explicitTrigger;

    var trigger = target.closest('button, input[type="submit"], a, [role="button"]');
    if (!trigger) return null;

    var label = normalize(
      trigger.value || trigger.textContent || trigger.getAttribute('aria-label') || ''
    );
    return /\bbuy\s*(now|it\s*now)\b/.test(label) ? trigger : null;
  }
  function forceRakhiBuyNow(event) {
    /*
     * FORCE RAKHI BUY NOW WITHOUT HIJACKING THE NATIVE POPUP
     * ------------------------------------------------------
     * When a Rakhi product has an unmatched city/pincode, remove only the
     * delivery-widget validation blockers and then let the original theme /
     * Shopify / GoKwik Buy Now click continue normally.
     *
     * Do NOT preventDefault(), do NOT stopPropagation(), and do NOT redirect
     * to /checkout here. This is what allows the existing Buy Now popup to
     * open and work normally.
     */
    if (!canBypassDeliveryValidation()) return;

    var trigger = isRakhiBuyNowTrigger(event.target);
    if (!trigger) return;

    if (event && event.isTrusted === true) {
      rakhiBuyRetryCount = 0;
    }
    lastRakhiBuyTrigger = trigger;

    enableUnavailableBypass();
    primeRakhiBypassProperties();
    removeRequiredMessage();

    trigger.setAttribute('data-og-rakhi-location-bypass', '1');
  }

  function prepareNativeFlow(event) {
    if (!canBypassDeliveryValidation()) return;
    var trigger = isBuyTrigger(event.target);
    if (!trigger && event.type !== 'submit') return;
    enableUnavailableBypass();
  }
  function syncBypassState() {
    if (canBypassDeliveryValidation()) {
      enableUnavailableBypass();
    } else {
      disableUnavailableBypass();
    }
  }
  window.__ogUnavailableLocation = isUnavailable;
  window.__ogCanBypassDeliveryValidation = canBypassDeliveryValidation;
  window.__ogPrepareUnavailableNativeFlow = enableUnavailableBypass;
  window.__ogSyncUnavailableBypass = syncBypassState;
  window.alert = function (message) {
    var text = normalize(message || '');
    if (
      canBypassDeliveryValidation() &&
      (
        text.indexOf('please fill required option') > -1 ||
        text.indexOf('please fill this required option') > -1 ||
        text.indexOf('please fill this option') > -1 ||
        text.indexOf('please fill required') > -1 ||
        text.indexOf('please select date, type, slot first') > -1 ||
        text.indexOf('please select date type slot first') > -1
      )
    ) {
      enableUnavailableBypass();
      primeRakhiBypassProperties();
      removeRequiredMessage();

      if (
        lastRakhiBuyTrigger &&
        lastRakhiBuyTrigger.isConnected &&
        rakhiBuyRetryCount < 1
      ) {
        rakhiBuyRetryCount += 1;
        setTimeout(function () {
          try {
            lastRakhiBuyTrigger.click();
          } catch (e) {}
        }, 0);
      }
      return;
    }
    return nativeAlert.apply(window, arguments);
  };
  window.addEventListener('pointerdown', prepareNativeFlow, true);
  window.addEventListener('click', prepareNativeFlow, true);
  window.addEventListener('click', forceRakhiBuyNow, true);
  window.addEventListener('submit', prepareNativeFlow, true);
  window.addEventListener('invalid', function (event) {
    if (!canBypassDeliveryValidation()) return;
    var root = document.getElementById('og-delivery-widget');
    if (
      root &&
      (
        root.contains(event.target) ||
        /^ogProp/.test(String(event.target && event.target.id || ''))
      )
    ) {
      event.preventDefault();
      enableUnavailableBypass();
    }
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'ogInlineLocationInput') {
      setTimeout(syncBypassState, 0);
    }
  }, true);
  document.addEventListener('click', function (event) {
    if (
      event.target &&
      event.target.closest &&
      event.target.closest('#ogInlineResetBtn')
    ) {
      setTimeout(syncBypassState, 0);
    }
  }, true);
  var bypassSyncTimer = null;
  var messageObserver = null;
  var observedMessage = null;
  var mountObserver = null;

  function scheduleBypassSync(delay) {
    clearTimeout(bypassSyncTimer);
    bypassSyncTimer = setTimeout(function () {
      syncBypassState();
      if (canBypassDeliveryValidation()) removeRequiredMessage();
    }, Number(delay || 40));
  }

  function observeUnavailableMessage() {
    var message = document.getElementById('ogInlineMessage');
    if (!message || message === observedMessage) return !!message;

    if (messageObserver) messageObserver.disconnect();
    observedMessage = message;
    messageObserver = new MutationObserver(function () {
      scheduleBypassSync(30);
    });
    messageObserver.observe(message, {
      childList: true,
      subtree: true,
      characterData: true
    });
    scheduleBypassSync(0);
    return true;
  }

  function addedNodeContainsDeliveryWidget(node) {
    if (!node || node.nodeType !== 1) return false;
    if (
      node.id === 'og-delivery-widget' ||
      node.id === 'ogInlineMessage'
    ) return true;
    return !!(
      node.querySelector &&
      node.querySelector('#og-delivery-widget, #ogInlineMessage')
    );
  }

  function mountUnavailableObserver() {
    observeUnavailableMessage();
    if (!document.body || mountObserver) return;

    mountObserver = new MutationObserver(function (mutations) {
      var shouldMount = mutations.some(function (mutation) {
        return Array.prototype.some.call(
          mutation.addedNodes || [],
          addedNodeContainsDeliveryWidget
        );
      });
      if (shouldMount) observeUnavailableMessage();
    });
    mountObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountUnavailableObserver, { once: true });
  } else {
    mountUnavailableObserver();
  }
})();
window.initOgGooglePlacesDelivery = function () {
  window.__ogGooglePlacesReady = true;
  if (typeof window.__initOgDeliveryCore === 'function') {
    window.__initOgDeliveryCore();
  }
};
(function () {
  'use strict';
  /* v12 invalidates rows created by the older city-only parser. */
  var SHEET_CACHE_KEY = 'og_delivery_sheet_cache_v12';
  var SHEET_STALE_CACHE_KEY = 'og_delivery_sheet_stale_v12';
  var SELECTION_CACHE_KEY = 'og_delivery_selection_v11';
  var SELECTION_COOKIE_KEY = 'og_delivery_selection_backup_v3';
  var googleAutocompleteService = null;
  var googlePlacesService = null;
  var googleGeocoder = null;
  var googleSessionToken = null;
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  function now() {
    return new Date();
  }
  function todayDate() {
    var d = now();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function ymd(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }
  function normalize(v) {
    return String(v || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function keyNorm(v) {
    return String(v || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }
  function escapeHtml(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function extractPincode(v) {
    var m = String(v || '').match(/\b\d{6}\b/);
    return m ? m[0] : '';
  }
  function toNumber(v) {
    if (v === true) return 1;
    if (v === false || v === null || v === undefined) return 0;
    var raw = String(v).trim();
    var compact = raw.replace(/\s+/g, '').toLowerCase();
    if (/^(yes|y|true|available|serviceable|enabled)$/i.test(raw)) return 1;
    if (/^(no|n|false|na|n\/a|notavailable|disabled)$/i.test(compact)) return 0;
    var n = Number(raw.replace(/[₹,\s]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }
  function money(v, currency) {
    var n = Number(v || 0);
    if (!Number.isFinite(n)) n = 0;
    return (currency || '₹') + String(n);
  }
  function displayPrice(v, currency) {
    var n = Number(v || 0);
    return n === 0 ? 'FREE' : money(n, currency);
  }
  function buildReadableLocation(parts) {
    var out = [];
    (parts || []).forEach(function (item) {
      item = String(item || '').trim();
      if (item && out.indexOf(item) === -1) out.push(item);
    });
    return out.join(', ');
  }
  function buildResolvedLocationLabel(pin, googleLabel, fallbackCity) {
    pin = String(pin || '').trim();
    var label = String(googleLabel || '').trim();
    var city = String(fallbackCity || '').trim();
    label = label
      .replace(/\b\d{6}\b\s*,?\s*/g, '')
      .replace(/^\s*,\s*|\s*,\s*$/g, '')
      .replace(/\s*,\s*/g, ', ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!label) label = city;
    return buildReadableLocation([pin, label]);
  }
  
  /*
   * Location search is intentionally independent from delivery-slot logic.
   * The JSON can contain a full address in one column or separate locality,
   * city, state and pincode columns.  Normalise both formats into the same
   * searchable shape so every Indian city/area/pincode can be found.
   */
  var INDIAN_STATE_NAMES = [
    'andhra pradesh', 'arunachal pradesh', 'assam', 'bihar', 'chhattisgarh',
    'goa', 'gujarat', 'haryana', 'himachal pradesh', 'jharkhand', 'karnataka',
    'kerala', 'madhya pradesh', 'maharashtra', 'manipur', 'meghalaya',
    'mizoram', 'nagaland', 'odisha', 'punjab', 'rajasthan', 'sikkim',
    'tamil nadu', 'telangana', 'tripura', 'uttar pradesh', 'uttarakhand',
    'west bengal', 'delhi', 'jammu and kashmir', 'ladakh',
    'andaman and nicobar islands', 'chandigarh', 'dadra and nagar haveli and daman and diu',
    'daman and diu', 'lakshadweep', 'puducherry'
  ];
  function cleanAddressPart(value) {
    return String(value || '')
      .replace(/\b\d{6}\b/g, '')
      .replace(/\s+/g, ' ')
      .replace(/^\s*[,-]+\s*|\s*[,-]+\s*$/g, '')
      .trim();
  }
  function isIndiaCountry(value) {
    var n = normalize(value).replace(/[.]/g, '');
    return n === 'india' || n === 'ind' || n === 'bharat';
  }
  function isIndianState(value) {
    var n = normalize(value).replace(/[.]/g, '');
    if (!n) return false;
    return INDIAN_STATE_NAMES.indexOf(n) > -1 ||
      INDIAN_STATE_NAMES.some(function (stateName) {
        return n === stateName + ' state';
      });
  }
  function splitAddressParts(value) {
    return String(value || '')
      .replace(/\b\d{6}\b/g, '')
      .split(/[,|;>]+/)
      .map(cleanAddressPart)
      .filter(Boolean);
  }
  function searchableText(row) {
    return normalize([
      row.rawLocation,
      row.displayAddress,
      row.locality,
      row.area,
      row.city,
      row.district,
      row.state,
      row.country,
      row.pincode
    ].join(' '));
  }
  function queryTokens(value) {
    return normalize(value)
      .replace(/[^a-z0-9]+/g, ' ')
      .split(' ')
      .filter(Boolean);
  }
  function rowSearchScore(row, query) {
    var q = normalize(query);
    if (!q) return -1;
    var qKey = keyNorm(q);
    var fields = [
      { value: row.pincode, weight: 2200 },
      { value: row.locality, weight: 1500 },
      { value: row.area, weight: 1450 },
      { value: row.city, weight: 1350 },
      { value: row.district, weight: 1250 },
      { value: row.state, weight: 1150 },
      { value: row.displayAddress, weight: 1000 },
      { value: row.rawLocation, weight: 900 },
      { value: row.country, weight: 300 }
    ];
    var score = -1;
    fields.forEach(function (field) {
      var value = normalize(field.value);
      if (!value) return;
      var valueKey = keyNorm(value);
      if (value === q) score = Math.max(score, field.weight + 100);
      else if (valueKey === qKey) score = Math.max(score, field.weight + 80);
      else if (value.indexOf(q) === 0 || valueKey.indexOf(qKey) === 0) {
        score = Math.max(score, field.weight + 50);
      } else if (value.indexOf(q) > -1 || valueKey.indexOf(qKey) > -1) {
        score = Math.max(score, field.weight);
      }
    });
    var tokens = queryTokens(q);
    var allTokensPresent = tokens.length > 1 && tokens.every(function (token) {
      return searchableText(row).indexOf(token) > -1;
    });
    if (allTokensPresent) score = Math.max(score, 850 + tokens.length * 10);
    return score;
  }
  function formatMetaDate(d) {
    return d.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }
  function formatSelectedDateLabel(d) {
    var t = todayDate();
    var tm = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
    if (ymd(d) === ymd(t)) return 'Today, ' + formatMetaDate(d);
    if (ymd(d) === ymd(tm)) return 'Tomorrow, ' + formatMetaDate(d);
    return formatMetaDate(d);
  }
  function getConfig() {
    var node = document.getElementById('og-delivery-config');
    if (!node) {
      console.error('[OG Delivery] Missing #og-delivery-config');
      return null;
    }
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.error('[OG Delivery] Invalid config JSON', e);
      return null;
    }
  }
  function fetchJson(url, options) {
    return fetch(url, options || {}).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (txt) {
          throw new Error(txt || ('HTTP ' + res.status));
        });
      }
      return res.json();
    });
  }
  function fetchCart() {
    return fetchJson('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
  }
  function postCartAdd(payload) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });
  }
  function postCartUpdate(updates) {
    return fetchJson('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
  }
  function dispatchCartRefresh() {
    [
      'cart:refresh',
      'cart:build',
      'cart:updated',
      'cart:change',
      'ajaxCart:updated'
    ].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name));
      window.dispatchEvent(new CustomEvent(name));
    });
    scheduleFeeLineScan(120);
    if (typeof window.__ogRenderCartDeliveryCharges === 'function') {
      window.__ogRenderCartDeliveryCharges(180);
    }
  }
  function openCartUi() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.dispatchEvent(new CustomEvent('cart:open'));
    var selectors = [
      '[data-cart-drawer-trigger]',
      '[data-drawer-id="cart"]',
      '.js-drawer-open-cart',
      '.header__icon--cart',
      '.cart-link',
      'a[href="/cart"]',
      'button[name="cart"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var trigger = document.querySelector(selectors[i]);
      if (trigger && typeof trigger.click === 'function') {
        try {
          trigger.click();
          return;
        } catch (e) {}
      }
    }
  }
  function markFeeLinesInDom() {
    var selectors = [
      '[data-cart-item]',
      '.cart-item',
      '.drawer__item',
      '.mini-cart__item',
      '.ajaxcart__product',
      '.cart-drawer__item',
      '.cart__item',
      '[class*="cart-item"]',
      '[class*="CartItem"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (line) {
      if (line.getAttribute('data-og-delivery-fee-line') === 'true') return;
      var text = normalize(line.textContent || '');
      if (
        text.indexOf('delivery fee') > -1 ||
        text.indexOf('shipping fee') > -1 ||
        text.indexOf('_og_delivery_fee') > -1
      ) {
        line.setAttribute('data-og-delivery-fee-line', 'true');
        line.classList.add('og-hide-delivery-fee-line');
      }
    });
  }

  var feeLineScanTimer = null;
  function scheduleFeeLineScan(delay) {
    clearTimeout(feeLineScanTimer);
    feeLineScanTimer = setTimeout(markFeeLinesInDom, Number(delay || 100));
  }
  function initGoogleServices() {
    if (!window.google || !window.google.maps || !window.google.maps.places) return false;
    try {
      googleAutocompleteService = googleAutocompleteService || new google.maps.places.AutocompleteService();
      googleGeocoder = googleGeocoder || new google.maps.Geocoder();
      if (!googlePlacesService) {
        var div = document.createElement('div');
        googlePlacesService = new google.maps.places.PlacesService(div);
      }
      if (!googleSessionToken && google.maps.places.AutocompleteSessionToken) {
        googleSessionToken = new google.maps.places.AutocompleteSessionToken();
      }
      return true;
    } catch (e) {
      return false;
    }
  }
  function initOgDelivery() {
    var root = document.getElementById('og-delivery-widget');
    var config = getConfig();
    if (!root || !config) return;
    if (root.getAttribute('data-og-enabled') !== 'true') return;
    if (root.__ogMounted) {
      if (typeof root.__ogSoftRestore === 'function') root.__ogSoftRestore();
      return;
    }
    root.__ogMounted = true;
    ensureRestoredLockStyles();
    var currency = config.currencySymbol || '₹';
    var sheetUrl = config.sheetUrl || '';
    var sheetCacheTtlMs = Number(config.sheetCacheTtlMs || 10800000);
    var sheetStaleCacheTtlMs = Number(config.sheetStaleCacheTtlMs || 86400000);
    var deliveryFeeProductId = Number(config.deliveryFeeProductId || 0);
    var feeVariantByAmount = config.feeVariantByAmount || {};
    var productForm =
      root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    var els = {
      input: document.getElementById('ogInlineLocationInput'),
      reset: document.getElementById('ogInlineResetBtn'),
      msg: document.getElementById('ogInlineMessage'),
      suggestions: document.getElementById('ogLocationSuggestions'),
      flow: document.getElementById('ogDeliveryFlow'),
      dateOptions: document.getElementById('ogDateOptions'),
      typeOptions: document.getElementById('ogTypeOptions'),
      slotTitle: document.getElementById('ogSlotTitle'),
      slotOptions: document.getElementById('ogSlotOptions'),
      summary: document.getElementById('ogDeliverySummary'),
      selectedLines: document.getElementById('ogSelectedLines'),
      modify: document.getElementById('ogDeliveryModify'),
      calendarPanel: document.getElementById('ogCalendarPanel'),
      calendarOverlay: document.getElementById('ogCalendarOverlay'),
      calendarClose: document.getElementById('ogCalendarClose'),
      calendarPrev: document.getElementById('ogCalendarPrev'),
      calendarNext: document.getElementById('ogCalendarNext'),
      calendarMonthLabel: document.getElementById('ogCalendarMonthLabel'),
      calendarDays: document.getElementById('ogCalendarDays'),
      propCity: document.getElementById('ogPropCity'),
      propPincode: document.getElementById('ogPropPincode'),
      propDate: document.getElementById('ogPropDate'),
      propType: document.getElementById('ogPropType'),
      propSlot: document.getElementById('ogPropSlot'),
      propChargeSummary: document.getElementById('ogPropChargeSummary'),
      propHiddenType: document.getElementById('ogPropHiddenType'),
      propHiddenCharge: document.getElementById('ogPropHiddenCharge'),
      propHiddenSelected: document.getElementById('ogPropHiddenSelected')
    };
    if (els.input) {
      /* City and locality names should never get browser spellcheck marks. */
      els.input.setAttribute('spellcheck', 'false');
      els.input.setAttribute('autocorrect', 'off');
      els.input.setAttribute('autocapitalize', 'words');
      els.input.setAttribute(
        'placeholder',
        'Enter city, area, state or 6 digit pincode'
      );
    }
    var sheetRows = [];
    var activeSuggestions = [];
    var suggestionTimer = null;
    var googleRequestToken = 0;
    var suggestionRequestId = 0;
    var fallbackRequestToken = 0;
    var isSubmitting = false;
    var state = {
      matchedLocation: null,
      selectedDate: '',
      selectedDateLabel: '',
      selectedType: '',
      selectedSlot: null,
      finalCharge: 0,
      finalChargeLabel: '',
      calendarMonth: null
    };
    var isEditingDeliverySelection = false;
    /*
     * True only when a completed selection was restored from storage.
     * It protects the restored summary from delayed Google/autocomplete/
     * theme events that can otherwise reset state after first paint.
     */
    var restoredSelectionLocked = false;
    function isUnavailableLocation() {
      return typeof window.__ogUnavailableLocation === 'function'
        ? window.__ogUnavailableLocation()
        : false;
    }
    function canProceedWithoutDeliverySelection() {
      return typeof window.__ogCanBypassDeliveryValidation === 'function'
        ? window.__ogCanBypassDeliveryValidation()
        : isUnavailableLocation();
    }
    function getCurrentProductForm() {
      return (
        root.closest('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]') ||
        productForm
      );
    }

    function ensureDeliveryStateStyles() {
      if (document.getElementById('og-delivery-state-style')) return;
      var style = document.createElement('style');
      style.id = 'og-delivery-state-style';
      style.textContent =
        '#ogDeliveryFlow.is-location-pending > *{' +
          'display:none!important;' +
        '}' +
        '#ogDeliveryFlow.is-location-pending > [data-og-date-section="true"]{' +
          'display:block!important;' +
        '}' +
        '#ogDeliveryFlow.is-location-pending .og-date-card{' +
          'opacity:.58!important;' +
          'cursor:not-allowed!important;' +
          'pointer-events:none!important;' +
          'background:#f7f7f7!important;' +
        '}' +
        '#ogDeliveryFlow.is-location-pending .og-date-card.is-active{' +
          'box-shadow:none!important;' +
        '}' +
        '#ogSelectedLines .og-summary-charge{' +
          'margin-top:3px!important;' +
          'font-size:15px!important;' +
          'line-height:1.4!important;' +
        '}' +
        '#ogSelectedLines .og-summary-charge__label{' +
          'color:#d35400!important;' +
          'font-weight:800!important;' +
        '}' +
        '#ogSelectedLines .og-summary-charge__value{' +
          'color:#087f23!important;' +
          'font-size:16px!important;' +
          'font-weight:900!important;' +
        '}' +
        '@media(max-width:749px){' +
          '#ogSelectedLines .og-summary-charge{font-size:14px!important;}' +
          '#ogSelectedLines .og-summary-charge__value{font-size:15px!important;}' +
        '}' +
        '.og-delivery__validation-hint{' +
          'margin:6px 0 0!important;' +
          'color:#b42318!important;' +
          'font-size:13px!important;' +
          'font-weight:700!important;' +
          'line-height:1.35!important;' +
        '}' +
        '.is-og-missing-step{' +
          'outline:2px solid rgba(180,35,24,.24)!important;' +
          'outline-offset:3px!important;' +
          'border-radius:6px!important;' +
        '}';
      document.head.appendChild(style);
    }


    function ensureRestoredLockStyles() {
      if (document.getElementById('og-restored-lock-style')) return;

      var style = document.createElement('style');
      style.id = 'og-restored-lock-style';
      style.textContent =
        '#og-delivery-widget[data-og-restored-lock="true"] .og-delivery__flow > .og-delivery__section{' +
          'display:none!important;' +
        '}' +
        '#og-delivery-widget[data-og-restored-lock="true"] .og-delivery__flow > [data-og-date-section="true"]{' +
          'display:block!important;' +
        '}' +
        '#og-delivery-widget[data-og-restored-lock="true"] #ogDeliverySummary{' +
          'display:flex!important;' +
        '}';

      document.head.appendChild(style);
    }

    function markDateSection() {
      if (!els.flow || !els.dateOptions) return;
      var section = els.dateOptions;
      while (section.parentElement && section.parentElement !== els.flow) {
        section = section.parentElement;
      }
      if (section && section.parentElement === els.flow) {
        section.setAttribute('data-og-date-section', 'true');
      }
    }

    function syncDeliveryFlowVisibility() {
      if (!els.flow) return;
      ensureDeliveryStateStyles();
      markDateSection();
      var unavailable = isUnavailableLocation();
      if (unavailable) {
        els.flow.hidden = true;
        els.flow.classList.remove('is-location-pending');
        return;
      }
      els.flow.hidden = false;
      els.flow.classList.toggle('is-location-pending', !state.matchedLocation);
    }
   function ensureUnavailableNoticeStyle() {
  if (document.getElementById('og-unavailable-notice-style')) return;
  var style = document.createElement('style');
  style.id = 'og-unavailable-notice-style';
  style.textContent =
    '.og-delivery__inline-message.is-unavailable{' +
      'display:block!important;' +
      'margin-top:12px!important;' +
      'padding:0!important;' +
      'background:transparent!important;' +
      'border:0!important;' +
      'color:inherit!important;' +
    '}' +
    '.og-unavailable-notice{' +
      'display:flex;' +
      'align-items:center;' +
      'justify-content:center;' +
      'gap:4px;' +
      'width:max-content;' +
      'max-width:100%;' +
      'margin:0 auto;' +
      'padding:8px 12px;' +
      'border-radius:4px;' +
      'background:#efffe8;' +
      'color:#111;' +
      'font-size:13px;' +
      'font-weight:600;' +
      'line-height:1.35;' +
      'text-align:center;' +
      'box-sizing:border-box;' +
      'flex-wrap:wrap;' +
    '}' +
    '.og-unavailable-notice__link{' +
      'color:#ff7a00!important;' +
      'font-weight:700!important;' +
      'text-decoration:none!important;' +
      'white-space:nowrap;' +
    '}' +
    '.og-unavailable-notice__link:hover{' +
      'text-decoration:underline!important;' +
    '}' +
    '@media(max-width:749px){' +
      '.og-unavailable-notice{' +
        'width:100%;' +
        'font-size:12px;' +
        'padding:8px 10px;' +
      '}' +
    '}';
  document.head.appendChild(style);
}
function setUnavailableMsg(pin) {
  if (!els.msg) return;
  ensureUnavailableNoticeStyle();
  var cleanPin = /^\d{6}$/.test(String(pin || '').trim())
    ? String(pin).trim()
    : '';
  var destinationText = cleanPin
    ? 'See Available Gifts To ' + cleanPin
    : 'See Available Gifts';
  els.msg.innerHTML =
    '<div class="og-unavailable-notice">' +
      '<span>This product cannot be delivered.</span>' +
      '<a href="https://shorturl.at/3aNav" class="og-unavailable-notice__link">' +
        escapeHtml(destinationText) +
      '</a>' +
    '</div>';
  els.msg.className = 'og-delivery__inline-message is-unavailable';
}
function setMsg(text, type) {
  if (!els.msg) return;
  els.msg.textContent = text || '';
  els.msg.className = 'og-delivery__inline-message' + (type ? ' is-' + type : '');
}
    function setValue(node, value) {
      if (node) node.value = value || '';
    }
    function ensurePropertyInput(name) {
      var form = getCurrentProductForm();
      if (!form) return null;
      var fullName = 'properties[' + name + ']';
      var node = form.querySelector('input[name="' + fullName + '"]');
      if (!node) {
        node = document.createElement('input');
        node.type = 'hidden';
        node.name = fullName;
        form.appendChild(node);
      }
      return node;
    }
    function updateFormProperty(name, value) {
      var node = ensurePropertyInput(name);
      if (node) node.value = value || '';
    }
    function pickFromObject(obj, names) {
      var normalized = {};
      Object.keys(obj || {}).forEach(function (key) {
        normalized[keyNorm(key)] = obj[key];
      });
      for (var i = 0; i < names.length; i++) {
        var val = normalized[keyNorm(names[i])];
        if (val !== undefined && val !== null && String(val).trim() !== '') {
          return val;
        }
      }
      return '';
    }
    function transformRows(rows) {
      return (Array.isArray(rows) ? rows : []).map(function (row) {
        var location = String(pickFromObject(row, [
          'DeliveryData',
          'Delivery Data',
          'Location',
          'Service Area',
          'Delivery Location',
          'Full Address',
          'Address',
          'City Pincode'
        ]) || '').trim();
        var localityFromCol = cleanAddressPart(pickFromObject(row, [
          'Locality',
          'Local Area',
          'Area Name',
          'Neighbourhood',
          'Neighborhood',
          'Sublocality',
          'Sub Locality'
        ]));
        var areaFromCol = cleanAddressPart(pickFromObject(row, [
          'Area',
          'Delivery Area',
          'Service Area Name',
          'Region'
        ]));
        var cityFromCol = String(pickFromObject(row, [
          'City',
          'Town',
          'Location City',
          'City Name'
        ]) || '').trim();
        var districtFromCol = cleanAddressPart(pickFromObject(row, [
          'District',
          'City District',
          'Location District'
        ]));
        var stateFromCol = cleanAddressPart(pickFromObject(row, [
          'State',
          'State Name',
          'Province',
          'Location State'
        ]));
        var countryFromCol = cleanAddressPart(pickFromObject(row, [
          'Country',
          'Country Name'
        ]));
        var pinFromCol = String(pickFromObject(row, [
          'Pincode',
          'Pin Code',
          'PinCode',
          'Postal Code',
          'PostalCode',
          'Zip',
          'ZIP Code'
        ]) || '').trim();
        var pin = extractPincode(pinFromCol) || extractPincode(location);
        var addressParts = splitAddressParts(location);
        var state = stateFromCol || addressParts.filter(isIndianState)[0] || '';
        var country = countryFromCol || addressParts.filter(isIndiaCountry)[0] || 'India';
        var stateIndex = state
          ? addressParts.findIndex(function (part) {
              return normalize(part) === normalize(state);
            })
          : -1;
        var city = cityFromCol || districtFromCol ||
          (stateIndex > 0 ? addressParts[stateIndex - 1] : addressParts[0]) || '';
        city = cleanAddressPart(city);
        var locality = localityFromCol ||
          (areaFromCol && normalize(areaFromCol) !== normalize(city) ? areaFromCol : '') ||
          (addressParts.length > 1 && normalize(addressParts[0]) !== normalize(city)
            ? addressParts[0]
            : '');
        var district = districtFromCol || '';
        if (!location) {
          location = buildReadableLocation([
            locality,
            city,
            state,
            country,
            pin
          ]);
        }
        var displayAddress = buildReadableLocation([
          locality,
          city,
          district,
          state,
          country
        ]);
        if (!displayAddress) {
          displayAddress = cleanAddressPart(location) || city;
        }
        if (!city) city = locality || displayAddress;
        var area = areaFromCol || locality;
        function p(names) {
          return toNumber(pickFromObject(row, names));
        }
        var obj = {
          rawLocation: location,
          city: city,
          locality: locality,
          area: area,
          district: district,
          state: state,
          country: country,
          pincode: pin,
          displayAddress: displayAddress,
          displayMeta: displayAddress,
          morning: p(['Morning Delivery', 'Morning']),
          morningCharge: p(['Morning Charge', 'Morning Delivery Charge', 'Morning Price']),
          express: p(['Express Delivery', 'Express']),
          expressCharge: p(['Express Charge', 'Express Delivery Charge', 'Express Price']),
          standard: p(['Standard Delivery', 'Standard']),
          standardCharge: p(['Standard Charge', 'Standard Delivery Charge', 'Standard Price']),
          fixedTime: p(['Fixed Time Delivery', 'Fixed Time', 'Fixed']),
          fixedTimeCharge: p(['Fixed Time Charge', 'Fixed Time Delivery Charge', 'Fixed Price']),
          midnight: p(['Midnight Delivery', 'Midnight']),
          midnightCharge: p(['Midnight Charge', 'Midnight Delivery Charge', 'Midnight Price']),
          freeSlot: p(['Free Slot', 'FreeSlot', 'Free']),
          nextDay: p(['Next Day Delivery', 'Next Day', 'NextDay']),
          nextDayCharge: p(['Next Day Charge', 'Next Day Delivery Charge', 'NextDay Charge', 'Next Day Price']),
          remoteDelivery: p(['Remote Delivery', 'Remote']),
          remoteCharge: p(['Remote Charge', 'Remote Area Charge', 'Remote Delivery Charge', 'Remote Price'])
        };
        if (obj.express > 1 && !obj.expressCharge) obj.expressCharge = obj.express;
        if (obj.morning > 1 && !obj.morningCharge) obj.morningCharge = obj.morning;
        if (obj.standard > 1 && !obj.standardCharge) obj.standardCharge = obj.standard;
        if (obj.fixedTime > 1 && !obj.fixedTimeCharge) obj.fixedTimeCharge = obj.fixedTime;
        if (obj.midnight > 1 && !obj.midnightCharge) obj.midnightCharge = obj.midnight;
        if (obj.nextDay > 1 && !obj.nextDayCharge) obj.nextDayCharge = obj.nextDay;
        if (obj.remoteDelivery > 1 && !obj.remoteCharge) obj.remoteCharge = obj.remoteDelivery;
        obj.searchText = searchableText(obj);
        return obj;
      }).filter(function (row) {
        return row.city || row.pincode;
      });
    }
    function readSheetCache(key, ttl) {
      try {
        var raw = sessionStorage.getItem(key) || localStorage.getItem(key);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.rows)) return null;
        if ((Date.now() - Number(parsed.ts || 0)) > ttl) return null;
        return parsed.rows;
      } catch (e) {
        return null;
      }
    }
    function writeSheetCache(rows) {
      var payload = JSON.stringify({
        ts: Date.now(),
        rows: rows
      });
      try { sessionStorage.setItem(SHEET_CACHE_KEY, payload); } catch (e) {}
      try { localStorage.setItem(SHEET_CACHE_KEY, payload); } catch (e) {}
      try { sessionStorage.setItem(SHEET_STALE_CACHE_KEY, payload); } catch (e) {}
      try { localStorage.setItem(SHEET_STALE_CACHE_KEY, payload); } catch (e) {}
    }
     function fetchSheetRows(forceRefresh) {
  if (!sheetUrl) return Promise.resolve([]);

  var requestUrl = sheetUrl;

  if (forceRefresh) {
    requestUrl +=
      (requestUrl.indexOf('?') > -1 ? '&' : '?') +
      '_og_refresh=' +
      Date.now();
  }

  return fetchJson(requestUrl, {
    cache: forceRefresh ? 'reload' : 'default',
    headers: { Accept: 'application/json' }
  }).then(function (json) {
    var rows = Array.isArray(json)
      ? json
      : (
          json &&
          (
            json.rows ||
            json.data ||
            json.values
          )
        ) || [];

    rows = transformRows(rows);
    sheetRows = rows;
    writeSheetCache(rows);

    return rows;
  });
}
    function bootSheetRows() {
  var fresh = readSheetCache(
    SHEET_CACHE_KEY,
    sheetCacheTtlMs
  );

  if (fresh && fresh.length) {
    sheetRows = fresh;
    return Promise.resolve(fresh);
  }

  var stale = readSheetCache(
    SHEET_STALE_CACHE_KEY,
    sheetStaleCacheTtlMs
  );

  if (stale && stale.length) {
    sheetRows = stale;

    fetchSheetRows(true).catch(function (err) {
      console.warn(
        '[OG Delivery] Background JSON refresh failed',
        err
      );
    });

    return Promise.resolve(stale);
  }

  return fetchSheetRows(false).catch(function (err) {
    console.error(
      '[OG Delivery] Sheet fetch failed',
      err
    );

    setMsg(
      'Delivery data loading failed. Please try again.',
      'error'
    );

    return [];
  });
}
    function findByPincode(pin) {
      pin = String(pin || '').trim();
      if (!pin) return null;
      for (var i = 0; i < sheetRows.length; i++) {
        if (String(sheetRows[i].pincode || '').trim() === pin) return sheetRows[i];
      }
      return null;
    }
    function findBestSheetRowForText(text) {
      var query = normalize(text);
      if (!query) return null;
      var ranked = sheetRows.map(function (row, index) {
        return {
          row: row,
          index: index,
          score: rowSearchScore(row, query)
        };
      }).filter(function (item) {
        return item.score > -1;
      });
      if (!ranked.length) return null;
      ranked.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        var aPin = /^\d{6}$/.test(String(a.row.pincode || '').trim())
          ? Number(a.row.pincode)
          : 999999;
        var bPin = /^\d{6}$/.test(String(b.row.pincode || '').trim())
          ? Number(b.row.pincode)
          : 999999;
        if (aPin !== bPin) return aPin - bPin;
        return a.index - b.index;
      });
      return ranked[0].row;
    }
    function findDefaultRowByCity(city) {
      var input = normalize(city);
      if (!input) return null;
      var exactCityRows = sheetRows.filter(function (row) {
        return normalize(row.city) === input &&
          /^\d{6}$/.test(String(row.pincode || '').trim());
      }).sort(function (a, b) {
        return Number(a.pincode) - Number(b.pincode);
      });
      return exactCityRows[0] || findBestSheetRowForText(input);
    }
    function findByCity(city) {
      var input = normalize(city);
      if (!input) return null;
      var matches = sheetRows.filter(function (row) {
        var cityNorm = normalize(row.city);
        var rawNorm = normalize(row.rawLocation);
        return (
          cityNorm === input ||
          rawNorm === input ||
          cityNorm.indexOf(input) > -1 ||
          rawNorm.indexOf(input) > -1 ||
          input.indexOf(cityNorm) > -1
        );
      });
      if (!matches.length) return null;
      var first = matches[0];
      function anyFlag(key) {
        return matches.some(function (r) {
          return Number(r[key] || 0) > 0;
        }) ? 1 : 0;
      }
      function maxVal(key) {
        return matches.reduce(function (a, r) {
          return Math.max(a, Number(r[key] || 0));
        }, 0);
      }
      return {
        rawLocation: first.rawLocation,
        city: first.city,
        pincode: '',
        displayMeta: first.displayMeta || first.rawLocation,
        morning: anyFlag('morning'),
        morningCharge: maxVal('morningCharge'),
        express: anyFlag('express'),
        expressCharge: maxVal('expressCharge'),
        standard: anyFlag('standard'),
        standardCharge: maxVal('standardCharge'),
        fixedTime: anyFlag('fixedTime'),
        fixedTimeCharge: maxVal('fixedTimeCharge'),
        midnight: anyFlag('midnight'),
        midnightCharge: maxVal('midnightCharge'),
        freeSlot: anyFlag('freeSlot'),
        nextDay: anyFlag('nextDay'),
        nextDayCharge: maxVal('nextDayCharge'),
        remoteDelivery: anyFlag('remoteDelivery'),
        remoteCharge: maxVal('remoteCharge')
      };
    }
    function hasSameDayType(row) {
      if (!row) return false;
      return !!(
        Number(row.morning || 0) ||
        Number(row.express || 0) ||
        Number(row.standard || 0) ||
        Number(row.fixedTime || 0) ||
        Number(row.midnight || 0) ||
        Number(row.freeSlot || 0)
      );
    }
    function isAfterCutoff() {
      return now().getHours() >= Number(config.cutoffHour || 20);
    }
    function getMinSelectableDate(match) {
      var d = todayDate();
      if (isAfterCutoff() || !hasSameDayType(match)) {
        d.setDate(d.getDate() + 1);
      }
      return d;
    }
    function getMaxSelectableDate() {
      var d = todayDate();
      d.setDate(d.getDate() + Number(config.defaultDateWindowDays || 90));
      return d;
    }
    function isDateDisabled(dateObj) {
      var key = ymd(dateObj);
      var min = getMinSelectableDate(state.matchedLocation);
      var max = getMaxSelectableDate();
      var only = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
      var minOnly = new Date(min.getFullYear(), min.getMonth(), min.getDate());
      var maxOnly = new Date(max.getFullYear(), max.getMonth(), max.getDate());
      if (only < minOnly) return true;
      if (only > maxOnly) return true;
      if (
        config.specialDates &&
        Array.isArray(config.specialDates.disabled) &&
        config.specialDates.disabled.indexOf(key) > -1
      ) {
        return true;
      }
      return false;
    }
    function getLocationLabel() {
      if (!state.matchedLocation) return '';
      return (
        state.matchedLocation.selectedDisplayLabel ||
        buildResolvedLocationLabel(
          state.matchedLocation.pincode,
          state.matchedLocation.displayAddress ||
            state.matchedLocation.displayMeta ||
            state.matchedLocation.rawLocation,
          state.matchedLocation.city
        ) ||
        ''
      );
    }
    function getTypeCfg(typeKey) {
      return config.deliveryTypes && config.deliveryTypes[typeKey]
        ? config.deliveryTypes[typeKey]
        : null;
    }
    function typeCharge(typeKey, row) {
      row = row || state.matchedLocation || {};
      var cfg = getTypeCfg(typeKey);
      var cfgCharge = cfg ? Number(cfg.defaultCharge || 0) : 0;
      if (typeKey === 'standard') return Number(row.standardCharge || cfgCharge || 0);
      if (typeKey === 'express') return Number(row.expressCharge || cfgCharge || 0);
      if (typeKey === 'morning') return Number(row.morningCharge || cfgCharge || 0);
      if (typeKey === 'fixed_time') return Number(row.fixedTimeCharge || cfgCharge || 0);
      if (typeKey === 'midnight') return Number(row.midnightCharge || cfgCharge || 0);
      if (typeKey === 'free_slot') return 0;
      if (typeKey === 'next_day_delivery') return Number(row.nextDayCharge || cfgCharge || 0);
      if (typeKey === 'remote_delivery') return Number(row.remoteCharge || cfgCharge || 0);
      return cfgCharge;
    }
    function allowedTypeKeysFromRow(row, selectedDate) {
      if (!row) return [];
      var out = [];
      var isToday = selectedDate === ymd(todayDate());
      var specialMeta = getSpecialDateMeta(selectedDate || '');
      if (Number(row.morning || 0) > 0) out.push('morning');
      if (Number(row.express || 0) > 0) out.push('express');
      if (Number(row.standard || 0) > 0) out.push('standard');
      if (Number(row.fixedTime || 0) > 0) out.push('fixed_time');
      if (Number(row.midnight || 0) > 0) out.push('midnight');
      if (Number(row.freeSlot || 0) > 0) out.push('free_slot');
      if (!isToday && Number(row.nextDay || 0) > 0) out.push('next_day_delivery');
      if (!isToday && (Number(row.remoteDelivery || 0) > 0 || Number(row.remoteCharge || 0) > 0)) {
        out.push('remote_delivery');
      }
      return out.filter(function (v, i, arr) {
        if (arr.indexOf(v) !== i || !getTypeCfg(v)) return false;

        /*
         * A limited date can intentionally expose only the listed delivery
         * services. Location-wise availability above is still respected.
         */
        if (
          specialMeta &&
          Array.isArray(specialMeta.allowedTypes) &&
          specialMeta.allowedTypes.length &&
          specialMeta.allowedTypes.indexOf(v) === -1
        ) {
          return false;
        }

        return true;
      });
    }
    function getSpecialDateMeta(dateKey) {
      /*
       * These two Rakhi dates are enforced in the widget itself so the
       * restriction cannot be skipped by an unpublished/stale config snippet.
       * Config-level limited-date settings still work for every other date.
       */
      var enforcedDateRules = {
        '2026-08-27': {
          allowedTypes: ['standard', 'midnight'],
          standardLastOrderHour: 20
        },
        '2026-08-28': {
          allowedTypes: ['standard', 'midnight'],
          standardLastOrderHour: 20
        }
      };
      var configuredRule =
        config.specialDates &&
        config.specialDates.limited &&
        config.specialDates.limited[dateKey]
          ? config.specialDates.limited[dateKey]
          : null;
      var enforcedRule = enforcedDateRules[dateKey] || null;

      if (!configuredRule && !enforcedRule) return null;
      return Object.assign({}, configuredRule || {}, enforcedRule || {});
    }
    function getFilteredSlotsForType(typeKey, selectedDate) {
      var cfg = getTypeCfg(typeKey);
      if (!cfg || !Array.isArray(cfg.slots)) return [];
      var slots = cfg.slots.map(function (slot) {
        return {
          label: slot.label,
          startHour: Number(slot.startHour || 0),
          startMinute: Number(slot.startMinute || 0),
          endHour: Number(slot.endHour || slot.startHour || 0),
          endMinute: Number(slot.endMinute || slot.startMinute || 0),
          extraCharge: Number(slot.extraCharge || 0)
        };
      });
      var meta = getSpecialDateMeta(selectedDate || '');
      if (meta && Array.isArray(meta.allowedSlots) && meta.allowedSlots.length) {
        slots = slots.filter(function (slot) {
          return meta.allowedSlots.indexOf(slot.label) > -1;
        });
      }
      if (selectedDate !== ymd(todayDate())) return slots;

      /*
       * TODAY SLOT CUTOFF:
       * Hide every slot 1 hour before its start time, exactly like the earlier flow.
       *
       * 27/28 Aug special-date type restrictions are still handled separately by
       * getSpecialDateMeta(), so Fixed Time and Express remain hidden there.
       */
      var currentMinutes = now().getHours() * 60 + now().getMinutes();
      var oneHourCutoffMinutes = currentMinutes + 60;

      slots = slots.filter(function (slot) {
        var startMinutes = Number(slot.startHour || 0) * 60 + Number(slot.startMinute || 0);
        return startMinutes > oneHourCutoffMinutes;
      });

      /*
       * Optional hard cutoff for Standard Delivery on a limited date.
       * This does NOT bypass the per-slot 1-hour cutoff above.
       */
      if (
        typeKey === 'standard' &&
        meta &&
        Number.isFinite(Number(meta.standardLastOrderHour))
      ) {
        var standardCutoffMinutes = Number(meta.standardLastOrderHour) * 60 +
          Number(meta.standardLastOrderMinute || 0);
        return currentMinutes < standardCutoffMinutes ? slots : [];
      }

      return slots;
    }
    function availableTypesForLocation(match, selectedDate) {
      if (!match || !selectedDate) return [];
      return allowedTypeKeysFromRow(match, selectedDate).map(function (key) {
        var cfg = getTypeCfg(key);
        var slots = getFilteredSlotsForType(key, selectedDate);
        if (!cfg || !slots.length) return null;
        return {
          key: key,
          label: cfg.label,
          charge: typeCharge(key, match)
        };
      }).filter(Boolean);
    }

    /*
     * The customer can keep a completed selection across product pages, but
     * a slot must never remain selected after its end time. These helpers are
     * also used when a page is reopened after the saved slot has expired.
     */
    var preferredTypeOrder = [
      'morning',
      'standard',
      'express',
      'fixed_time',
      'midnight',
      'free_slot',
      'next_day_delivery',
      'remote_delivery'
    ];

    function getTypeOrderIndex(typeKey) {
      var index = preferredTypeOrder.indexOf(typeKey);
      return index === -1 ? 999 : index;
    }

    function makeDateFromKey(dateKey) {
      var parts = String(dateKey || '').split('-');
      if (parts.length !== 3) return null;
      var year = Number(parts[0]);
      var month = Number(parts[1]) - 1;
      var day = Number(parts[2]);
      if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return null;
      }
      return new Date(year, month, day);
    }

    function getSlotStartTimestamp(dateKey, slot) {
      var date = makeDateFromKey(dateKey);
      if (!date || !slot) return 0;
      date.setHours(
        Number(slot.startHour || 0),
        Number(slot.startMinute || 0),
        0,
        0
      );
      return date.getTime();
    }

    function getAvailableSlotCandidates(match, dateKey) {
      if (!match || !dateKey) return [];
      var date = makeDateFromKey(dateKey);
      if (!date || isDateDisabled(date)) return [];

      return allowedTypeKeysFromRow(match, dateKey).reduce(function (out, typeKey) {
        var slots = getFilteredSlotsForType(typeKey, dateKey);
        slots.forEach(function (slot) {
          var expiry = getSelectionExpiry(dateKey, slot);
          if (!expiry || Date.now() >= expiry) return;
          out.push({
            typeKey: typeKey,
            slot: slot,
            start: getSlotStartTimestamp(dateKey, slot),
            typeOrder: getTypeOrderIndex(typeKey)
          });
        });
        return out;
      }, []);
    }

    function getReplacementDeliveryCandidate(match, oldDateKey) {
      if (!match) return null;

      var today = todayDate();
      var todayKey = ymd(today);
      var startDate = makeDateFromKey(oldDateKey);
      if (!startDate || startDate < today) startDate = today;

      var maxDate = getMaxSelectableDate();
      var cursor = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

      while (cursor <= maxDate) {
        var dateKey = ymd(cursor);
        var candidates = getAvailableSlotCandidates(match, dateKey);

        if (candidates.length) {
          if (dateKey === todayKey) {
            /* Same day: choose the nearest future slot, never an old slot. */
            candidates.sort(function (a, b) {
              return (a.start - b.start) || (a.typeOrder - b.typeOrder);
            });
          } else {
            /* Next day or later: choose the latest available slot that day. */
            candidates.sort(function (a, b) {
              return (b.start - a.start) || (a.typeOrder - b.typeOrder);
            });
          }

          return {
            dateKey: dateKey,
            slot: candidates[0].slot,
            typeKey: candidates[0].typeKey
          };
        }

        cursor.setDate(cursor.getDate() + 1);
      }

      return null;
    }

    function calculateCharges() {
      var cfg = getTypeCfg(state.selectedType);
      var base = cfg ? typeCharge(state.selectedType, state.matchedLocation) : 0;
      var extra = Number((state.selectedSlot && state.selectedSlot.extraCharge) || 0);
      state.finalCharge = Number(base || 0) + Number(extra || 0);
      state.finalChargeLabel = cfg ? cfg.label + ' ' + money(state.finalCharge || 0, currency) : '';
    }
    function isReady() {
      return !!(
        state.matchedLocation &&
        state.selectedDate &&
        state.selectedType &&
        state.selectedSlot
      );
    }

    var deliveryValidationTimer = null;
    function clearDeliveryValidation() {
      clearTimeout(deliveryValidationTimer);
      root.querySelectorAll('.og-delivery__validation-hint').forEach(function (node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
      });
      root.querySelectorAll('.is-og-missing-step').forEach(function (node) {
        node.classList.remove('is-og-missing-step');
      });
    }

    function getDeliverySection(node) {
      return node && node.closest ? node.closest('.og-delivery__section') : null;
    }

    function addValidationHint(target, message) {
      if (!target) return;
      var hint = document.createElement('div');
      hint.className = 'og-delivery__validation-hint';
      hint.setAttribute('role', 'alert');
      hint.textContent = message;
      if (target.classList && target.classList.contains('og-type-card-wrap')) {
        var typeButton = target.querySelector('.og-type-card');
        if (typeButton && typeButton.parentNode === target) {
          typeButton.insertAdjacentElement('afterend', hint);
        } else {
          target.insertBefore(hint, target.firstChild);
        }
        return;
      }
      var title = target.querySelector && target.querySelector(
        '.og-delivery__section-title, .og-delivery__label'
      );
      if (title) {
        title.insertAdjacentElement('afterend', hint);
      } else {
        target.insertBefore(hint, target.firstChild);
      }
    }

    function scrollToMissingTarget(target, focusNode) {
      if (!target) target = root;
      target.classList.add('is-og-missing-step');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (focusNode && typeof focusNode.focus === 'function') {
        try {
          focusNode.focus({ preventScroll: true });
        } catch (err) {
          try { focusNode.focus(); } catch (ignore) {}
        }
      }
      deliveryValidationTimer = setTimeout(function () {
        if (target && target.classList) target.classList.remove('is-og-missing-step');
      }, 1800);
    }

    function focusFirstMissingDeliveryStep() {
      clearDeliveryValidation();
      var locationSection = root.querySelector('.og-delivery__section--location');
      var dateSection = getDeliverySection(els.dateOptions);
      var typeSection = getDeliverySection(els.typeOptions);
      var target = null;
      var focusNode = null;
      var message = '';

      if (!state.matchedLocation) {
        target = locationSection || root;
        focusNode = els.input || null;
        message = 'Enter or select the receiver\'s exact delivery location first.';
        setMsg(message, 'error');
      } else if (!state.selectedDate) {
        target = dateSection || els.dateOptions || root;
        message = 'Please choose a delivery date.';
      } else if (!state.selectedType) {
        target = typeSection || els.typeOptions || root;
        message = 'Please choose a delivery option.';
      } else if (!state.selectedSlot) {
        target = root.querySelector(
          '[data-og-type-wrap="' + state.selectedType + '"]'
        ) || typeSection || root;
        var selectedCfg = getTypeCfg(state.selectedType);
        message = 'Please choose a time slot' +
          (selectedCfg && selectedCfg.label ? ' for ' + selectedCfg.label : '') +
          '.';
      } else {
        return false;
      }

      if (target !== locationSection) addValidationHint(target, message);
      scrollToMissingTarget(target, focusNode);
      return true;
    }

    function applyProperties() {
      calculateCharges();
      var cfg = getTypeCfg(state.selectedType);
      var ready = isReady();
      var city = ready ? String(state.matchedLocation.city || '') : '';
      var pin = ready ? String(state.matchedLocation.pincode || '') : '';
      var date = ready ? String(state.selectedDateLabel || '') : '';
      var type = ready && cfg ? String(cfg.label || '') : '';
      var slot = ready ? String(state.selectedSlot.label || '') : '';
      var charge = ready ? String(state.finalChargeLabel || '') : '';
      setValue(els.propCity, city);
      setValue(els.propPincode, pin);
      setValue(els.propDate, date);
      setValue(els.propType, type);
      setValue(els.propSlot, slot);
      setValue(els.propChargeSummary, charge);
      setValue(els.propHiddenType, state.selectedType || '');
      setValue(els.propHiddenCharge, ready ? String(state.finalCharge || 0) : '');
      setValue(els.propHiddenSelected, ready ? '1' : '');
      updateFormProperty('📍 Delivery City', city);
      updateFormProperty('Delivery Pincode', pin);
      updateFormProperty('Select Date', date);
      updateFormProperty('Pick Delivery Type', type);
      updateFormProperty('Time Slot', slot);
      updateFormProperty('Delivery Charge', charge);
      updateFormProperty('_og_delivery_type', state.selectedType || '');
      updateFormProperty('_og_delivery_total_charge', ready ? String(state.finalCharge || 0) : '');
      updateFormProperty('_og_delivery_selected', ready ? '1' : '');
    }
    function getProductFormPayload() {
      applyProperties();
      calculateCharges();
      var form = getCurrentProductForm();
      if (!form) {
        console.error('[OG Delivery] Product form not found');
        return null;
      }
      var formData = new FormData(form);
      var id = Number(formData.get('id'));
      var quantity = Number(formData.get('quantity') || 1);
      if (!id) {
        var variantInput =
          form.querySelector('[name="id"]') ||
          document.querySelector('form[action*="/cart/add"] [name="id"]');
        id = variantInput ? Number(variantInput.value) : 0;
      }
      if (!id) {
        console.error('[OG Delivery] Variant id missing');
        return null;
      }
      var cfg = getTypeCfg(state.selectedType);
      var properties = {
        '📍 Delivery City': state.matchedLocation ? String(state.matchedLocation.city || '') : '',
        'Delivery Pincode': state.matchedLocation ? String(state.matchedLocation.pincode || '') : '',
        'Select Date': state.selectedDateLabel || '',
        'Pick Delivery Type': cfg ? cfg.label : '',
        'Time Slot': state.selectedSlot ? state.selectedSlot.label : '',
        'Delivery Charge': state.finalChargeLabel || '',
        '_og_delivery_type': state.selectedType || '',
        '_og_delivery_total_charge': String(state.finalCharge || 0),
        '_og_delivery_selected': '1'
      };
      Object.keys(properties).forEach(function (key) {
        if (properties[key] === '') delete properties[key];
      });
      return {
        id: id,
        quantity: quantity > 0 ? quantity : 1,
        properties: properties
      };
    }
    function getFeeVariantIdForAmount(amount) {
      amount = Number(amount || 0);
      if (amount <= 0) return null;
      var key = String(amount);
      if (Object.prototype.hasOwnProperty.call(feeVariantByAmount, key)) {
        return Number(feeVariantByAmount[key]);
      }
      console.warn('[OG Delivery] Missing fee variant for amount:', key);
      return null;
    }
    function getItemDeliveryCharge(item) {
      var props = (item && item.properties) || {};
      var amount = Number(props._og_delivery_total_charge || 0);
      if (!Number.isFinite(amount) || amount < 0) amount = 0;
      var label = String(props['Delivery Charge'] || props['Delivery Fee'] || '').trim();
      if (!amount && label) {
        var match = label.match(/₹\s*([0-9,]+)/);
        if (match) amount = Number(String(match[1]).replace(/,/g, '')) || 0;
      }
      return { amount: amount, label: label };
    }
    function getCartSingleDeliveryCharge(cart) {
      var best = { amount: 0, label: '' };
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        var isFee =
          Number(item.product_id || 0) === deliveryFeeProductId ||
          String(props._og_delivery_fee || '') === '1';
        if (isFee) return;
        var charge = getItemDeliveryCharge(item);
        if (charge.amount > best.amount) {
          best = charge;
        } else if (!best.label && charge.label) {
          best.label = charge.label;
        }
      });
      return best;
    }
    function getFeeItemProperties(amount, label) {
      return {
        '_og_delivery_fee': '1',
        '_og_delivery_total_charge': String(Number(amount || 0)),
        'Delivery Fee': label || ('Delivery Charge ' + money(amount, currency))
      };
    }
    function syncFeeItemInCart() {
      if (!deliveryFeeProductId) return Promise.resolve();
      var selectedCharge = { amount: 0, label: '' };
      var feeVariantId = null;
      return fetchCart()
        .then(function (cart) {
          selectedCharge = getCartSingleDeliveryCharge(cart);
          feeVariantId = getFeeVariantIdForAmount(selectedCharge.amount);
          var updates = {};
          var keptCorrectFee = false;
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var isFee =
              Number(item.product_id || 0) === deliveryFeeProductId ||
              String(props._og_delivery_fee || '') === '1';
            if (!isFee) return;
            var isCorrect = feeVariantId && Number(item.variant_id) === Number(feeVariantId);
            if (isCorrect && !keptCorrectFee) {
              keptCorrectFee = true;
              if (Number(item.quantity || 0) !== 1) updates[item.key] = 1;
            } else {
              updates[item.key] = 0;
            }
          });
          if (Object.keys(updates).length) {
            return postCartUpdate(updates).then(function () {
              return { keptCorrectFee: keptCorrectFee };
            });
          }
          return { keptCorrectFee: keptCorrectFee };
        })
        .then(function (result) {
          if (!feeVariantId || result.keptCorrectFee) return null;
          return postCartAdd({
            id: feeVariantId,
            quantity: 1,
            properties: getFeeItemProperties(selectedCharge.amount, selectedCharge.label)
          });
        })
        .catch(function (err) {
          console.error('[OG Delivery] Fee sync failed', err);
        });
    }
    function ensureCartChargeStyle() {
      if (document.getElementById('og-cart-charge-style')) return;
      var style = document.createElement('style');
      style.id = 'og-cart-charge-style';
      style.textContent =
        '.og-cart-charge-row{' +
          'display:flex!important;' +
          'align-items:center!important;' +
          'gap:4px!important;' +
          'width:100%!important;' +
          'margin:3px 0 5px!important;' +
          'padding:0!important;' +
          'font-size:12px!important;' +
          'line-height:1.35!important;' +
          'visibility:visible!important;' +
          'opacity:1!important;' +
        '}' +
        '.og-cart-charge-row__label{' +
          'color:#a63b00!important;' +
          'font-weight:800!important;' +
        '}' +
        '.og-cart-charge-row__value{' +
          'color:#087a2f!important;' +
          'font-size:13px!important;' +
          'font-weight:900!important;' +
        '}' +
        '[data-og-delivery-fee-line="true"]{display:none!important;}';
      document.head.appendChild(style);
    }

    function isDeliveryFeeCartItem(item) {
      var props = (item && item.properties) || {};
      return !!(
        Number(item && item.product_id || 0) === deliveryFeeProductId ||
        String(props._og_delivery_fee || '') === '1' ||
        normalize(item && item.product_title || '').indexOf('delivery fee') > -1 ||
        normalize(item && item.title || '').indexOf('delivery fee') > -1
      );
    }

    function hasDeliveryDetails(item) {
      var props = (item && item.properties) || {};
      return !!(
        props['📍 Delivery City'] ||
        props['Delivery City'] ||
        props['Delivery Pincode'] ||
        props['Select Date'] ||
        props['Pick Delivery Type'] ||
        props['Time Slot'] ||
        props['Delivery Charge'] ||
        props['_og_delivery_total_charge'] ||
        props['_og_delivery_selected']
      );
    }

    function getFallbackFeeCharge(cart) {
      var result = { amount: 0, label: '' };
      (cart.items || []).forEach(function (item) {
        if (!isDeliveryFeeCartItem(item)) return;
        var props = item.properties || {};
        var amount = Number(props._og_delivery_total_charge || 0);
        if (!amount) amount = Number(item.final_line_price || item.line_price || item.final_price || item.price || 0) / 100;
        if (amount > result.amount) result.amount = amount;
        if (!result.label) result.label = String(props['Delivery Fee'] || '').trim();
      });
      return result;
    }

    function getDeliveryItemsForCart(cart) {
      return (cart.items || []).filter(function (item) {
        return !isDeliveryFeeCartItem(item) && hasDeliveryDetails(item);
      });
    }

    function getCartDrawerRoot() {
      return (
        document.querySelector('[id^="CartDrawerBody-"]') ||
        document.getElementById('CartDrawer') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('.cart-drawer') ||
        document.querySelector('[class*="cart-drawer"]') ||
        document.querySelector('[class*="drawer"][class*="cart"]')
      );
    }

    function escapeCssValue(value) {
      value = String(value || '');
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }
      return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function findCartItemNode(root, item) {
      if (!root || !item) return null;
      var variantId = String(item.variant_id || '').trim();
      var key = String(item.key || '').trim();
      var handle = String(item.handle || '').trim();
      var node = null;

      if (variantId) {
        node = root.querySelector(
          'li.cart-item[data-variant-id="' + escapeCssValue(variantId) + '"], ' +
          '[id^="CartDrawer-Item-"][data-variant-id="' + escapeCssValue(variantId) + '"]'
        );
      }
      if (!node && key) {
        node = root.querySelector('[data-key="' + escapeCssValue(key) + '"]');
      }
      if (!node && handle) {
        node = root.querySelector(
          'li.cart-item[data-handle="' + escapeCssValue(handle) + '"], ' +
          '[id^="CartDrawer-Item-"][data-handle="' + escapeCssValue(handle) + '"]'
        );
      }
      return node;
    }

    function findTitleInsertionPoint(cartItem) {
      if (!cartItem) return null;

      var exactTitleBlock = cartItem.querySelector(
        '.cart-item__details .grid.flex-1 > .block'
      );
      if (exactTitleBlock) return exactTitleBlock;

      var details =
        cartItem.querySelector('.cart-item__details') ||
        cartItem.querySelector('[class*="cart-item__details"]');
      if (!details) return null;

      var options = details.querySelector('.cart-item__options');
      if (options && options.previousElementSibling) {
        return options.previousElementSibling;
      }

      var title = details.querySelector(
        '.cart-item__title, [class*="product-title"], [class*="item-title"], a[href*="/products/"], h2, h3, h4'
      );
      return title || details.firstElementChild || details;
    }

    var cartChargeTimer = null;
    var cartChargeRendering = false;

    function renderCartDeliveryCharges() {
      if (cartChargeRendering) return;
      var root = getCartDrawerRoot();
      if (!root) return;
      cartChargeRendering = true;
      ensureCartChargeStyle();

      fetchCart().then(function (cart) {
        root.querySelectorAll('.og-cart-charge-row').forEach(function (node) {
          node.remove();
        });

        var fallback = getFallbackFeeCharge(cart);
        var deliveryItems = getDeliveryItemsForCart(cart);

        deliveryItems.forEach(function (item) {
          var cartItem = findCartItemNode(root, item);
          if (!cartItem) return;

          var anchor = findTitleInsertionPoint(cartItem);
          if (!anchor || !anchor.parentNode) return;

          var charge = getItemDeliveryCharge(item);
          var amount = Number(charge.amount || 0);
          var label = String(charge.label || '').trim();

          if (!amount && fallback.amount) amount = Number(fallback.amount || 0);
          if (!label && fallback.label) label = String(fallback.label || '').trim();

          var value = amount > 0 ? money(amount, currency) : '';
          if (!value && label) {
            var match = label.match(/₹\s*([0-9,]+)/);
            value = match ? ('₹' + String(match[1]).replace(/,/g, '')) : label;
          }
          if (!value) return;

          var row = document.createElement('div');
          row.className = 'og-cart-charge-row';
          row.setAttribute('data-og-variant-id', String(item.variant_id || ''));
          row.innerHTML =
            '<span class="og-cart-charge-row__label">Delivery Charge:</span>' +
            '<span class="og-cart-charge-row__value">' + escapeHtml(value) + '</span>';

          anchor.parentNode.insertBefore(row, anchor.nextSibling);
        });
      }).catch(function (err) {
        console.error('[OG Delivery] Cart charge display failed', err);
      }).then(function () {
        cartChargeRendering = false;
      });
    }

    function scheduleCartChargeRender(delay) {
      clearTimeout(cartChargeTimer);
      cartChargeTimer = setTimeout(renderCartDeliveryCharges, Number(delay || 200));
    }

    window.__ogRenderCartDeliveryCharges = scheduleCartChargeRender;

    ['cart:open', 'cart:refresh', 'cart:updated', 'cart:change', 'ajaxCart:updated'].forEach(function (name) {
      document.addEventListener(name, function () { scheduleCartChargeRender(120); });
      window.addEventListener(name, function () { scheduleCartChargeRender(120); });
    });

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest(
        '.header__icon--cart, [data-cart-drawer-trigger], a[href="/cart"], button[name="cart"], [class*="quantity"], [class*="remove"]'
      )) {
        scheduleCartChargeRender(100);
        scheduleFeeLineScan(120);
      }
    });

    var cartMutationSelector =
      '#CartDrawer, cart-drawer, .cart-drawer, [id^="CartDrawerBody-"], ' +
      '[data-cart-item], .cart-item, .drawer__item, .mini-cart__item, ' +
      '.ajaxcart__product, .cart-drawer__item, .cart__item';

    function isCartMutation(mutation) {
      var changedNodes = Array.prototype.slice.call(mutation.addedNodes || [])
        .concat(Array.prototype.slice.call(mutation.removedNodes || []));
      if (
        changedNodes.length &&
        changedNodes.every(function (node) {
          return !!(
            node &&
            node.nodeType === 1 &&
            node.matches &&
            node.matches('.og-cart-charge-row')
          );
        })
      ) return false;

      var target = mutation && mutation.target;
      if (
        target &&
        target.nodeType === 1 &&
        target.closest &&
        target.closest(cartMutationSelector)
      ) return true;

      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        if (!node || node.nodeType !== 1) return false;
        if (node.matches && node.matches('.og-cart-charge-row')) return false;
        return !!(
          (node.matches && node.matches(cartMutationSelector)) ||
          (node.querySelector && node.querySelector(cartMutationSelector))
        );
      });
    }

    var cartChargeObserver = new MutationObserver(function (mutations) {
      if (!mutations.some(isCartMutation)) return;
      scheduleFeeLineScan(80);
      scheduleCartChargeRender(140);
    });

    cartChargeObserver.observe(document.body, { childList: true, subtree: true });
    scheduleCartChargeRender(350);
    scheduleFeeLineScan(380);

    function writeSelectionCookie(raw) {
      if (!raw) return;
      try {
        document.cookie =
          SELECTION_COOKIE_KEY + '=' + encodeURIComponent(raw) +
          '; path=/; max-age=172800; SameSite=Lax';
      } catch (e) {}
    }

    function readSelectionCookie() {
      try {
        var prefix = SELECTION_COOKIE_KEY + '=';
        var parts = String(document.cookie || '').split(';');
        for (var i = 0; i < parts.length; i++) {
          var item = parts[i].trim();
          if (item.indexOf(prefix) === 0) {
            return decodeURIComponent(item.slice(prefix.length));
          }
        }
      } catch (e) {}
      return '';
    }

    function clearSelectionCookie() {
      try {
        document.cookie =
          SELECTION_COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
      } catch (e) {}
    }

    function clearSelectionCache() {
      try { sessionStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      try { localStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      clearSelectionCookie();
    }

    function getSelectionExpiry(selectedDate, selectedSlot) {
      if (!selectedDate || !selectedSlot) return 0;

      var parts = String(selectedDate).split('-');
      if (parts.length !== 3) return 0;

      var year = Number(parts[0]);
      var month = Number(parts[1]) - 1;
      var day = Number(parts[2]);

      if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return 0;
      }

      var startHour = Number(selectedSlot.startHour);
      var startMinute = Number(selectedSlot.startMinute);
      var endHour = Number(selectedSlot.endHour);
      var endMinute = Number(selectedSlot.endMinute);

      if (!Number.isFinite(startHour)) startHour = 0;
      if (!Number.isFinite(startMinute)) startMinute = 0;
      if (!Number.isFinite(endHour)) endHour = 23;
      if (!Number.isFinite(endMinute)) endMinute = 59;

      var expiry = new Date(year, month, day, endHour, endMinute, 59, 999);

      /* Midnight/overnight slots end on the following calendar day. */
      var startMinutes = startHour * 60 + startMinute;
      var endMinutes = endHour * 60 + endMinute;
      if (endMinutes <= startMinutes) {
        expiry.setDate(expiry.getDate() + 1);
      }

      /*
       * The saved selection remains valid until the selected delivery
       * slot itself finishes. This keeps the same delivery selection
       * across product pages and browser refreshes without a fixed
       * one-hour timeout.
       */
      return expiry.getTime();
    }

    function isSavedSelectionValid(parsed) {
      if (
        !parsed ||
        !parsed.matchedLocation ||
        !parsed.selectedDate ||
        !parsed.selectedType ||
        !parsed.selectedSlot
      ) {
        return false;
      }

      var expiry = Number(parsed.expiresAt || 0);

      /* Backward compatibility for older cached selections. */
      if (!expiry) {
        expiry = getSelectionExpiry(parsed.selectedDate, parsed.selectedSlot);
      }

      if (!expiry || Date.now() >= expiry) {
        return false;
      }

      return true;
    }

    function saveSelection() {
      if (!isReady()) return;

      calculateCharges();

      var expiresAt = getSelectionExpiry(
        state.selectedDate,
        state.selectedSlot
      );

      if (!expiresAt || Date.now() >= expiresAt) {
        return;
      }

      var payload = JSON.stringify({
        ts: Date.now(),
        expiresAt: expiresAt,
        matchedLocation: state.matchedLocation,
        selectedDate: state.selectedDate,
        selectedDateLabel: state.selectedDateLabel,
        selectedType: state.selectedType,
        selectedSlot: state.selectedSlot,
        finalCharge: state.finalCharge
      });

      try { sessionStorage.setItem(SELECTION_CACHE_KEY, payload); } catch (e) {}
      try { localStorage.setItem(SELECTION_CACHE_KEY, payload); } catch (e) {}
      writeSelectionCookie(payload);
    }

    function readSelectionCache() {
      var candidates = [];

      try {
        var sessionRaw = sessionStorage.getItem(SELECTION_CACHE_KEY);
        var localRaw = localStorage.getItem(SELECTION_CACHE_KEY);
        var cookieRaw = readSelectionCookie();

        if (sessionRaw) {
          try { candidates.push(JSON.parse(sessionRaw)); } catch (e) {}
        }
        if (localRaw) {
          try { candidates.push(JSON.parse(localRaw)); } catch (e) {}
        }
        if (cookieRaw) {
          try { candidates.push(JSON.parse(cookieRaw)); } catch (e) {}
        }
      } catch (e) {}

      candidates.sort(function (a, b) {
        return Number((b && b.ts) || 0) - Number((a && a.ts) || 0);
      });

      for (var i = 0; i < candidates.length; i++) {
        if (!isSavedSelectionValid(candidates[i])) continue;

        try {
          var raw = JSON.stringify(candidates[i]);
          try { sessionStorage.setItem(SELECTION_CACHE_KEY, raw); } catch (e) {}
          try { localStorage.setItem(SELECTION_CACHE_KEY, raw); } catch (e) {}
          writeSelectionCookie(raw);
        } catch (e) {}

        return candidates[i];
      }

      return null;
    }

    function readLatestSelectionSnapshot() {
      var candidates = [];
      try {
        var sessionRaw = sessionStorage.getItem(SELECTION_CACHE_KEY);
        var localRaw = localStorage.getItem(SELECTION_CACHE_KEY);
        var cookieRaw = readSelectionCookie();

        if (sessionRaw) {
          try { candidates.push(JSON.parse(sessionRaw)); } catch (e) {}
        }
        if (localRaw) {
          try { candidates.push(JSON.parse(localRaw)); } catch (e) {}
        }
        if (cookieRaw) {
          try { candidates.push(JSON.parse(cookieRaw)); } catch (e) {}
        }
      } catch (e) {}

      candidates.sort(function (a, b) {
        return Number((b && b.ts) || 0) - Number((a && a.ts) || 0);
      });

      return candidates.length ? candidates[0] : null;
    }

    function clearSelectedSlotOnly() {
      state.selectedDate = '';
      state.selectedDateLabel = '';
      state.selectedType = '';
      state.selectedSlot = null;
      state.finalCharge = 0;
      state.finalChargeLabel = '';
    }

    function restoreExpiredSelection() {
      var stale = readLatestSelectionSnapshot();
      if (!stale || !stale.matchedLocation) return false;

      state.matchedLocation = stale.matchedLocation;
      var replacement = getReplacementDeliveryCandidate(
        state.matchedLocation,
        stale.selectedDate || ymd(todayDate())
      );

      if (replacement) {
        state.selectedDate = replacement.dateKey;
        var replacementDate = makeDateFromKey(replacement.dateKey);
        state.selectedDateLabel = replacementDate
          ? formatSelectedDateLabel(replacementDate)
          : '';
        state.selectedType = replacement.typeKey;
        state.selectedSlot = replacement.slot;
        state.finalCharge = 0;
        state.finalChargeLabel = '';
        isEditingDeliverySelection = false;
        restoredSelectionLocked = true;
        root.setAttribute('data-og-restored-lock', 'true');
        if (els.input) els.input.value = getLocationLabel();
        renderAll();
        saveSelection();
        setMsg('Your delivery slot was updated to the next available slot.', 'success');
        return true;
      }

      clearSelectionCache();
      clearSelectedSlotOnly();
      isEditingDeliverySelection = false;
      restoredSelectionLocked = false;
      root.removeAttribute('data-og-restored-lock');
      if (els.input) els.input.value = getLocationLabel();
      renderAll();
      setMsg('Your previous delivery slot has ended. Please choose a new slot.', 'error');
      return true;
    }

    function restoreSelection() {
      var parsed = readSelectionCache();

      /*
       * A completed delivery selection is GLOBAL for all Express-tag
       * product pages in this browser. Do not force the customer to
       * select date/type/slot again on every product page.
       *
       * It remains valid until the selected delivery slot ends.
       */
      if (!isSavedSelectionValid(parsed)) return restoreExpiredSelection();

      state.matchedLocation = parsed.matchedLocation;
      state.selectedDate = parsed.selectedDate || '';
      state.selectedDateLabel = parsed.selectedDateLabel || '';
      state.selectedType = parsed.selectedType || '';
      state.selectedSlot = parsed.selectedSlot || null;
      state.finalCharge = Number(parsed.finalCharge || 0);

      /*
       * IMPORTANT:
       * Do not re-check the saved choice against the newly opened
       * product's freshly rendered delivery list here. The customer's
       * completed selection is intentionally carried across Express
       * product pages until its date/time expires.
       *
       * Revalidation here was causing a valid saved selection to be
       * cleared and the next product page to show "Choose delivery
       * option" again.
       */

      if (els.input) {
        els.input.value = getLocationLabel();
      }

      isEditingDeliverySelection = false;
      restoredSelectionLocked = true;
      root.setAttribute('data-og-restored-lock', 'true');

      renderAll();
      applyProperties();
      toggleReset();

      if (state.matchedLocation) {
        setMsg('Location found! We deliver to this area.', 'success');
      }

      return true;
    }

    function refreshActiveDeliverySelection() {
      if (
        isSubmitting ||
        isEditingDeliverySelection ||
        !isReady()
      ) {
        return;
      }

      var expiry = getSelectionExpiry(
        state.selectedDate,
        state.selectedSlot
      );

      if (!expiry || Date.now() < expiry) return;

      var oldDateKey = state.selectedDate;
      var replacement = getReplacementDeliveryCandidate(
        state.matchedLocation,
        oldDateKey
      );

      if (!replacement) {
        clearSelectionCache();
        clearSelectedSlotOnly();
        restoredSelectionLocked = false;
        root.removeAttribute('data-og-restored-lock');
        renderAll();
        setMsg('Your previous delivery slot has ended. Please choose a new slot.', 'error');
        return;
      }

      state.selectedDate = replacement.dateKey;
      var replacementDate = makeDateFromKey(replacement.dateKey);
      state.selectedDateLabel = replacementDate
        ? formatSelectedDateLabel(replacementDate)
        : '';
      state.selectedType = replacement.typeKey;
      state.selectedSlot = replacement.slot;
      state.finalCharge = 0;
      state.finalChargeLabel = '';

      if (els.input) els.input.value = getLocationLabel();
      renderAll();
      saveSelection();
      setMsg('Your delivery slot was updated to the next available slot.', 'success');
    }

    var selectionRefreshTimer = null;
    function startSelectionRefreshMonitor() {
      if (selectionRefreshTimer) return;
      var interval = Number(config.selectionRefreshIntervalMs || 900000);
      if (!Number.isFinite(interval) || interval < 60000) interval = 900000;
      selectionRefreshTimer = window.setInterval(
        refreshActiveDeliverySelection,
        interval
      );
    }

    function resetAll() {
      restoredSelectionLocked = false;
      root.removeAttribute('data-og-restored-lock');
      state.matchedLocation = null;
      state.selectedDate = '';
      state.selectedDateLabel = '';
      state.selectedType = '';
      state.selectedSlot = null;
      state.finalCharge = 0;
      state.finalChargeLabel = '';
      if (els.input) els.input.value = '';
      if (els.summary) els.summary.hidden = true;
      if (els.suggestions) els.suggestions.hidden = true;
      setMsg('', '');
      syncDeliveryFlowVisibility();
      renderDateOptions();
      applyProperties();
      toggleReset();
      clearSelectionCache();
      syncFeeItemInCart();
    }
    function toggleReset() {
      if (!els.reset) return;
      els.reset.hidden = !((els.input && els.input.value.trim()) || state.matchedLocation);
    }
    function selectDateValue(dateValue) {
      if (dateValue === 'calendar') {
        openCalendar();
        return;
      }
      var parts = dateValue.split('-');
      var dateObj = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      if (isDateDisabled(dateObj)) return;
      state.selectedDate = dateValue;
      state.selectedDateLabel = formatSelectedDateLabel(dateObj);
      state.selectedType = '';
      state.selectedSlot = null;
      var options = availableTypesForLocation(state.matchedLocation, state.selectedDate);
      if (options.length === 1) {
        state.selectedType = options[0].key;
      }
      renderAll();
      closeCalendar();
      setTimeout(function () {
        if (els.typeOptions) {
          els.typeOptions.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }, 120);
    }
    function renderDateOptions() {
      if (!els.dateOptions) return;
      var locationPending = !state.matchedLocation;
      var t = todayDate();
      var tm = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
      var items = [
        {
          value: ymd(t),
          title: 'Today',
          meta: formatMetaDate(t),
          disabled: locationPending || isDateDisabled(t)
        },
        {
          value: ymd(tm),
          title: 'Tomorrow',
          meta: formatMetaDate(tm),
          disabled: locationPending || isDateDisabled(tm)
        },
        {
          value: 'calendar',
          title: 'Later',
          meta: 'Pick A Date',
          disabled: locationPending
        }
      ];
      els.dateOptions.innerHTML = items.map(function (item) {
        var active = item.value !== 'calendar' && state.selectedDate === item.value ? ' is-active' : '';
        var disabled = item.disabled ? ' is-disabled' : '';
        return (
          '<button type="button" class="og-date-card' + active + disabled + '" data-og-date="' + escapeHtml(item.value) + '"' +
          (item.disabled ? ' disabled aria-disabled="true"' : '') + '>' +
            '<span class="og-date-card__title">' + escapeHtml(item.title) + '</span>' +
            '<span class="og-date-card__meta">' + escapeHtml(item.meta) + '</span>' +
          '</button>'
        );
      }).join('');
    }
    function getDeliveryTypeIcon(typeKey) {
      var icons = {
        morning:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 18h16M6.3 14.5a5.8 5.8 0 0 1 11.4 0M12 3v3M4.2 7.2l2.1 2.1M19.8 7.2l-2.1 2.1M2 14.5h2.5M19.5 14.5H22"/></svg>',
        standard:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>',
        express:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m13.5 2-8 11h6l-1 9 8-12h-6z"/></svg>',
        fixed_time:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
        midnight:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 15.5A8 8 0 0 1 8.5 5a8.2 8.2 0 1 0 10.5 10.5Z"/><path d="M17.5 4.5v3M16 6h3M20.5 9v2M19.5 10h2"/></svg>',
        remote_delivery:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"/><circle cx="12" cy="10" r="2"/></svg>',
        free_slot:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>',
        next_day_delivery:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18M9 15h6"/></svg>'
      };
      return icons[typeKey] || icons.standard;
    }

    function getDeliveryTypeSubtitle(typeKey, slots) {
      slots = Array.isArray(slots) ? slots : [];
      if (slots.length === 1) return slots[0].label || '';
      if (typeKey === 'express') return 'Select an express time slot';
      if (typeKey === 'fixed_time') return 'Select a fixed delivery time';
      if (typeKey === 'standard') return 'Select a convenient time slot';
      if (typeKey === 'remote_delivery') return 'Select an available delivery slot';
      if (typeKey === 'next_day_delivery') return 'Select an available delivery slot';
      return 'Select a convenient time slot';
    }

    function renderInlineSlotButtons(typeKey, slots) {
      if (!Array.isArray(slots) || slots.length <= 1) return '';
      return (
        '<div class="og-type-card__slots">' +
          '<div class="og-delivery__slot-grid">' +
            slots.map(function (slot, index) {
              var active =
                state.selectedType === typeKey &&
                state.selectedSlot &&
                state.selectedSlot.label === slot.label
                  ? ' is-active'
                  : '';
              return (
                '<button type="button" class="og-slot-card' + active + '"' +
                  ' data-og-inline-slot-index="' + index + '"' +
                  ' data-og-inline-slot-type="' + escapeHtml(typeKey) + '"' +
                  ' aria-pressed="' + (active ? 'true' : 'false') + '">' +
                  '<span class="og-slot-card__label">' + escapeHtml(slot.label) + '</span>' +
                  '<span class="og-slot-card__check" aria-hidden="true">✓</span>' +
                '</button>'
              );
            }).join('') +
          '</div>' +
        '</div>'
      );
    }

    function renderTypeOptions() {
      if (!els.typeOptions) return;
      if (!state.selectedDate) {
        els.typeOptions.innerHTML = '<div class="og-delivery__empty">Select delivery date first.</div>';
        return;
      }

      var options = availableTypesForLocation(state.matchedLocation, state.selectedDate);

      var preferredTypeOrder = [
        'morning',
        'standard',
        'express',
        'fixed_time',
        'midnight'
      ];
      options.sort(function (a, b) {
        var ai = preferredTypeOrder.indexOf(a.key);
        var bi = preferredTypeOrder.indexOf(b.key);
        if (ai === -1) ai = 999;
        if (bi === -1) bi = 999;
        return ai - bi;
      });

      if (!options.length) {
        els.typeOptions.innerHTML = '<div class="og-delivery__empty">No delivery type available for this date.</div>';
        return;
      }

      els.typeOptions.innerHTML = options.map(function (item) {
        var slots = getFilteredSlotsForType(item.key, state.selectedDate);
        var hasMultipleSlots = slots.length > 1;
        var isSelectedType = state.selectedType === item.key;
        var active = isSelectedType ? ' is-active' : '';
        var expanded = hasMultipleSlots && isSelectedType;
        var price = displayPrice(item.charge, currency);
        var priceClass = Number(item.charge || 0) === 0 ? ' is-free' : '';
        var subtitle = getDeliveryTypeSubtitle(item.key, slots);

        return (
          '<div class="og-type-card-wrap' + active + '" data-og-type-wrap="' + escapeHtml(item.key) + '">' +
            '<button type="button" class="og-type-card' + active + '"' +
              ' data-og-type="' + escapeHtml(item.key) + '"' +
              (hasMultipleSlots
                ? ' aria-expanded="' + (expanded ? 'true' : 'false') + '"'
                : ' aria-pressed="' + (isSelectedType && state.selectedSlot ? 'true' : 'false') + '"') +
            '>' +
              '<span class="og-type-card__icon" aria-hidden="true">' +
                getDeliveryTypeIcon(item.key) +
              '</span>' +

              '<span class="og-type-card__body">' +
                '<span class="og-type-card__title">' + escapeHtml(item.label) + '</span>' +
                '<span class="og-type-card__subtitle">' + escapeHtml(subtitle) + '</span>' +
              '</span>' +

              '<span class="og-type-card__right">' +
                '<span class="og-type-card__price' + priceClass + '">' + escapeHtml(price) + '</span>' +
                (hasMultipleSlots
                  ? '<span class="og-type-card__chevron' + (expanded ? ' is-open' : '') + '" aria-hidden="true"></span>'
                  : '') +
              '</span>' +
            '</button>' +

            (expanded ? renderInlineSlotButtons(item.key, slots) : '') +
          '</div>'
        );
      }).join('');
    }

    function renderSlotOptions() {
      if (!els.slotOptions || !els.slotTitle) return;

      var cfg = getTypeCfg(state.selectedType);
      if (!state.selectedType || !cfg) {
        els.slotTitle.textContent = '';
        els.slotOptions.innerHTML = '';
        return;
      }

      var slots = getFilteredSlotsForType(state.selectedType, state.selectedDate);
      els.slotTitle.textContent = slots.length > 1 ? 'Select Time Slot for ' + cfg.label : '';

      if (slots.length <= 1) {
        els.slotOptions.innerHTML = '';
        return;
      }

      els.slotOptions.innerHTML = slots.map(function (slot, index) {
        var active = state.selectedSlot && state.selectedSlot.label === slot.label ? ' is-active' : '';
        return (
          '<button type="button" class="og-slot-card' + active + '" data-og-slot-index="' + index + '">' +
            '<span class="og-slot-card__label">' + escapeHtml(slot.label) + '</span>' +
            '<span class="og-slot-card__check" aria-hidden="true">✓</span>' +
          '</button>'
        );
      }).join('');
    }
    function renderSummary() {
      if (!els.summary || !els.selectedLines) return;
      calculateCharges();
      var cfg = getTypeCfg(state.selectedType);
      var ready = isReady();
      if (!ready || !cfg) {
        els.summary.hidden = true;
        return;
      }
      var lines = [
        ['Delivery City', state.matchedLocation.city || '-'],
        ['Delivery Pincode', state.matchedLocation.pincode || '-'],
        ['Delivery Date', state.selectedDateLabel],
        ['Delivery Type', cfg.label],
        ['Delivery Slot', state.selectedSlot.label],
        ['Delivery Charge', state.finalChargeLabel]
      ];
      els.selectedLines.innerHTML = lines.map(function (pair) {
        if (pair[0] === 'Delivery Charge') {
          return '<div class="og-summary-charge">' +
            '<span class="og-summary-charge__label">Delivery Charge:</span> ' +
            '<span class="og-summary-charge__value">' + escapeHtml(pair[1]) + '</span>' +
          '</div>';
        }
        return '<div><b>' + escapeHtml(pair[0]) + ':</b> ' + escapeHtml(pair[1]) + '</div>';
      }).join('');
      els.summary.hidden = false;
    }
    function renderAll() {
      /*
       * Last-line protection against ALL late async/theme events.
       * While the restored lock exists, rehydrate from storage BEFORE
       * anything can render the fresh chooser.
       */
      if (
        restoredSelectionLocked &&
        !isEditingDeliverySelection
      ) {
        /*
         * GoKwik-safe restore lock:
         * once a completed selection has been restored on this page, the
         * in-memory selection stays authoritative. Only a REAL customer click
         * on Reset / Change / date/type/slot can unlock it.
         */
        if (els.input) {
          els.input.value = getLocationLabel();
        }
        root.setAttribute('data-og-restored-lock', 'true');
      }

      syncDeliveryFlowVisibility();
      renderDateOptions();
      renderTypeOptions();
      renderSlotOptions();
      renderSummary();
      applyProperties();
      toggleReset();

      var summaryMode =
        (isReady() && !isEditingDeliverySelection) ||
        (
          restoredSelectionLocked &&
          root.getAttribute('data-og-restored-lock') === 'true'
        );

      root.classList.toggle('is-summary-mode', summaryMode);

      if (els.summary) {
        els.summary.hidden = !summaryMode;
      }

      if (typeof window.__ogSyncUnavailableBypass === 'function') {
        setTimeout(window.__ogSyncUnavailableBypass, 0);
      }
    }
    function renderCalendar() {
      if (!els.calendarDays || !els.calendarMonthLabel) return;
      var base = state.calendarMonth || new Date(todayDate().getFullYear(), todayDate().getMonth(), 1);
      var year = base.getFullYear();
      var month = base.getMonth();
      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      var todayKey = ymd(todayDate());
      var selectedKey = state.selectedDate || '';
      els.calendarMonthLabel.textContent = base.toLocaleDateString('en-IN', {
        month: 'long',
        year: 'numeric'
      });
      var minDate = getMinSelectableDate(state.matchedLocation);
      var minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
      var thisMonth = new Date(year, month, 1);
      if (els.calendarPrev) {
        els.calendarPrev.disabled = thisMonth <= minMonth;
      }
      var html = '';
      for (var i = 0; i < firstDay.getDay(); i++) {
        html += '<button type="button" class="og-calendar__day is-empty" tabindex="-1" aria-hidden="true"></button>';
      }
      for (var day = 1; day <= lastDay.getDate(); day++) {
        var dateObj = new Date(year, month, day);
        var dateKey = ymd(dateObj);
        var disabled = isDateDisabled(dateObj);
        var cls = 'og-calendar__day';
        if (disabled) cls += ' is-disabled';
        if (dateKey === todayKey) cls += ' is-today';
        if (dateKey === selectedKey) cls += ' is-selected';
        html += '<button type="button" class="' + cls + '" data-og-calendar-date="' + dateKey + '"' +
          (disabled ? ' disabled aria-disabled="true"' : '') + '>' + day + '</button>';
      }
      var totalCells = firstDay.getDay() + lastDay.getDate();
      var remaining = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7);
      for (var j = 0; j < remaining; j++) {
        html += '<button type="button" class="og-calendar__day is-empty" tabindex="-1" aria-hidden="true"></button>';
      }
      els.calendarDays.innerHTML = html;
    }
    function openCalendar() {
      var selectedDate = state.selectedDate
        ? new Date(state.selectedDate + 'T00:00:00')
        : getMinSelectableDate(state.matchedLocation);
      state.calendarMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
      renderCalendar();
      if (els.calendarPanel) {
        els.calendarPanel.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
    }
    function closeCalendar() {
      if (els.calendarPanel) els.calendarPanel.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    function getSheetSuggestions(input) {
      var q = normalize(input);
      if (!q || q.length < 2) return [];
      var ranked = [];
      var seen = {};
      sheetRows.forEach(function (row, rowIndex) {
        var score = rowSearchScore(row, q);
        if (score < 0) return;
        var city = String(row.city || '').trim();
        var pin = String(row.pincode || '').trim();
        var raw = String(row.rawLocation || '').trim();
        var address = String(
          row.displayAddress || row.displayMeta || raw || city
        ).trim();
        var key = normalize(address + '|' + pin);
        if (seen[key]) return;
        seen[key] = true;
        ranked.push({
          source: 'sheet',
          score: score,
          rowIndex: rowIndex,
          title: address,
          meta: pin ? 'Pincode: ' + pin : 'India delivery location',
          city: city,
          locality: String(row.locality || row.area || '').trim(),
          state: String(row.state || '').trim(),
          pincode: pin,
          raw: raw,
          row: row
        });
      });
      ranked.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        var aPin = /^\d{6}$/.test(a.pincode) ? Number(a.pincode) : 999999;
        var bPin = /^\d{6}$/.test(b.pincode) ? Number(b.pincode) : 999999;
        if (aPin !== bPin) return aPin - bPin;
        return a.rowIndex - b.rowIndex;
      });
      return ranked.slice(0, 12).map(function (item) {
        delete item.score;
        delete item.rowIndex;
        return item;
      });
    }
    function cleanSuggestionLabel(item) {
      var label = String(item && item.title || '').trim();
      var pin = String(
        item && item.pincode ||
        extractPincode(item && item.meta || '') ||
        extractPincode(label) ||
        ''
      ).trim();

      if (pin) {
        label = label.replace(new RegExp('\\b' + pin + '\\b', 'g'), '');
      }

      label = label
        .replace(/\s*,\s*/g, ', ')
        .replace(/,{2,}/g, ',')
        .replace(/^\s*,\s*|\s*,\s*$/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      if (label && !/(^|,\s*)india$/i.test(label)) {
        label += ', India';
      }

      return label || String(item && item.meta || '').replace(/^Pincode:\s*/i, '').trim();
    }

    function locationPinIcon() {
      return '' +
        '<span class="og-delivery__suggestion-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M12 21s6-5.34 6-11A6 6 0 1 0 6 10c0 5.66 6 11 6 11Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<circle cx="12" cy="10" r="2.2" stroke="currentColor" stroke-width="1.8"/>' +
          '</svg>' +
        '</span>';
    }

    function renderSuggestions(items) {
      if (!els.suggestions) return;
      if (!items || !items.length) {
        els.suggestions.innerHTML = '';
        els.suggestions.hidden = true;
        activeSuggestions = [];
        return;
      }

      activeSuggestions = items.slice(0, 6);
      els.suggestions.innerHTML = activeSuggestions.map(function (item, index) {
        var pin = String(
          item.pincode ||
          extractPincode(item.meta || '') ||
          extractPincode(item.title || '') ||
          ''
        ).trim();
        var label = cleanSuggestionLabel(item);
        var pinHtml = pin
          ? '<span class="og-delivery__suggestion-pin">' + escapeHtml(pin) + '</span>'
          : '';

        return (
          '<button type="button" class="og-delivery__suggestion" data-og-suggestion-index="' + index + '" aria-label="Select ' + escapeHtml(label) + '">' +
            locationPinIcon() +
            '<span class="og-delivery__suggestion-title">' + escapeHtml(label) + '</span>' +
            pinHtml +
          '</button>'
        );
      }).join('');
      els.suggestions.hidden = false;
    }
    /*
     * Google Places gives the richest autocomplete list when it is enabled.
     * Photon/OpenStreetMap is a no-key fallback for stores where the Google
     * Places library is not loaded; this is what prevents a permanent
     * "Searching delivery locations" state.
     */
    function getFallbackLocationSuggestions(input, done) {
      var requestToken = ++fallbackRequestToken;
      var url = 'https://photon.komoot.io/api/?q=' +
        encodeURIComponent(String(input || '').trim()) +
        '&limit=8&lang=en&bbox=68,6,97,37';
      fetchJson(url, {
        mode: 'cors',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (json) {
        if (requestToken !== fallbackRequestToken) return;
        var features = json && Array.isArray(json.features) ? json.features : [];
        var seen = {};
        var items = features.map(function (feature) {
          var p = feature && feature.properties ? feature.properties : {};
          var pin = extractPincode(
            p.postcode || p.postalcode || p.postal_code || ''
          );
          var label = buildReadableLocation([
            p.name,
            p.street,
            p.suburb,
            p.locality,
            p.city,
            p.district,
            p.state,
            p.country || 'India'
          ]);
          if (!label) label = String(p.name || p.city || p.state || '').trim();
          var sheetMatch = findBestSheetRowForText(label);
          if (!pin && sheetMatch && /^\d{6}$/.test(String(sheetMatch.pincode || '').trim())) {
            pin = String(sheetMatch.pincode).trim();
          }
          var key = normalize(label + '|' + pin);
          if (!label || seen[key]) return null;
          seen[key] = true;
          return {
            source: 'fallback',
            title: label,
            meta: pin ? 'Pincode: ' + pin : '',
            pincode: pin,
            sheetMatch: sheetMatch || null
          };
        }).filter(Boolean);
        done(items);
      }).catch(function () {
        if (requestToken === fallbackRequestToken) done([]);
      });
    }
    function getFallbackPincodeForLabel(label, done) {
      getFallbackLocationSuggestions(label, function (items) {
        var match = (items || []).find(function (item) {
          return /^\d{6}$/.test(String(item.pincode || '').trim());
        });
        done(
          match ? String(match.pincode).trim() : '',
          match && match.sheetMatch ? match.sheetMatch : null
        );
      });
    }
    function getGoogleSuggestions(input, done) {
      if (!initGoogleServices() || !googleAutocompleteService) {
        getFallbackLocationSuggestions(input, done);
        return;
      }
      var token = ++googleRequestToken;
      googleAutocompleteService.getPlacePredictions({
        input: input,
        componentRestrictions: { country: config.googleCountry || 'in' },
        types: ['geocode'],
        sessionToken: googleSessionToken || undefined
      }, function (predictions, status) {
        if (token !== googleRequestToken) return;
        if (
          !predictions ||
          !predictions.length ||
          status !== google.maps.places.PlacesServiceStatus.OK
        ) {
          getFallbackLocationSuggestions(input, done);
          return;
        }
        done(predictions.slice(0, 8).map(function (p) {
          var title =
            p.structured_formatting && p.structured_formatting.main_text
              ? p.structured_formatting.main_text
              : p.description;
          var meta =
            p.structured_formatting && p.structured_formatting.secondary_text
              ? p.structured_formatting.secondary_text
              : p.description;
          var fullDescription = p.description || buildReadableLocation([title, meta]);
          var sheetMatch = findBestSheetRowForText(fullDescription);
          var matchPin = sheetMatch && /^\d{6}$/.test(String(sheetMatch.pincode || '').trim())
            ? String(sheetMatch.pincode).trim()
            : '';
          return {
            source: 'google',
            title: fullDescription || title,
            meta: matchPin ? 'Pincode: ' + matchPin : '',
            placeId: p.place_id,
            pincode: matchPin,
            sheetMatch: sheetMatch || null
          };
        }));
      });
    }
    function mergeSuggestions(localItems, googleItems) {
      var out = [];
      var seen = {};
      (googleItems || []).concat(localItems || []).forEach(function (item) {
        if (!item) return;
        var key = normalize([
          item.title,
          item.meta,
          item.pincode || ''
        ].join('|'));
        if (!key || seen[key]) return;
        seen[key] = true;
        out.push(item);
      });
      out.sort(function (a, b) {
        var aHasPin = extractPincode(a.pincode || a.title || a.meta) ? 1 : 0;
        var bHasPin = extractPincode(b.pincode || b.title || b.meta) ? 1 : 0;
        return bHasPin - aHasPin;
      });
      return out.slice(0, 12);
    }
    function showCombinedSuggestions(input) {
      var value = String(input || '').trim();
      if (value.length < 2) {
        googleRequestToken++;
        renderSuggestions([]);
        return;
      }
      var requestId = ++suggestionRequestId;
      var localItems = getSheetSuggestions(value);
      renderSuggestions(localItems);
      if (localItems.length) {
        setMsg('Select a delivery location.', '');
      }
      getGoogleSuggestions(value, function (googleItems) {
        if (!els.input || els.input.value.trim() !== value) return;
        if (requestId !== suggestionRequestId) return;
        var merged = mergeSuggestions(localItems, googleItems);
        renderSuggestions(merged);
        setMsg(
          merged.length ? 'Select a delivery location.' : '',
          ''
        );
      });
    }
     function chooseMatchedLocation(match, inputLabel, resolvedPin) {
  /*
   * Prevent delayed Google Places/location callbacks from overwriting
   * a delivery that has already been restored from storage.
   */
  if (
    restoredSelectionLocked &&
        !isEditingDeliverySelection
  ) {
    if (els.input) els.input.value = getLocationLabel();
    renderSummary();
    root.classList.add('is-summary-mode');
    if (els.summary) els.summary.hidden = false;
    return;
  }

  if (!match) {
    if (restoredSelectionLocked && !isEditingDeliverySelection) {
      if (els.input) els.input.value = getLocationLabel();
      renderSummary();
      root.classList.add('is-summary-mode');
      if (els.summary) els.summary.hidden = false;
      applyProperties();
      toggleReset();
      return;
    }

    state.matchedLocation = null;
    state.selectedDate = '';
    state.selectedDateLabel = '';
    state.selectedType = '';
    state.selectedSlot = null;
    state.finalCharge = 0;
    state.finalChargeLabel = '';
    var unavailablePin =
      String(resolvedPin || extractPincode(inputLabel) || '').trim();
    if (els.input) {
      els.input.value = unavailablePin
        ? buildResolvedLocationLabel(
            unavailablePin,
            inputLabel || els.input.value || '',
            ''
          )
        : (inputLabel || els.input.value || '');
    }
    if (els.suggestions) {
      els.suggestions.hidden = true;
      els.suggestions.innerHTML = '';
    }
    if (els.flow) els.flow.hidden = true;
    if (els.summary) els.summary.hidden = true;
    applyProperties();
    toggleReset();
    if (isEditingDeliverySelection) {
      clearSelectionCache();
    }
    setUnavailableMsg(unavailablePin);
    syncDeliveryFlowVisibility();
    return;
  }
  var resolvedDisplayLabel = buildResolvedLocationLabel(
    match.pincode,
    inputLabel || match.displayMeta || match.rawLocation,
    match.city
  );
  state.matchedLocation = Object.assign({}, match, {
    selectedDisplayLabel: resolvedDisplayLabel
  });
  match = state.matchedLocation;
  var min = getMinSelectableDate(match);
  state.selectedDate = ymd(min);
  state.selectedDateLabel = formatSelectedDateLabel(min);
  state.selectedType = '';
  state.selectedSlot = null;
  var options = availableTypesForLocation(match, state.selectedDate);
  if (options.length === 1) {
    state.selectedType = options[0].key;
  }
  if (els.input) {
    els.input.value = getLocationLabel();
  }
  if (els.suggestions) {
    els.suggestions.hidden = true;
    els.suggestions.innerHTML = '';
  }
  setMsg('Location found! We deliver to this area.', 'success');
  renderAll();
  saveSelection();
}
    function askForExactPincode(inputLabel) {
      if (
        restoredSelectionLocked &&
        !isEditingDeliverySelection
      ) {
        if (els.input) els.input.value = getLocationLabel();
        renderSummary();
        root.classList.add('is-summary-mode');
        if (els.summary) els.summary.hidden = false;
        return;
      }

      state.matchedLocation = null;
      state.selectedDate = '';
      state.selectedDateLabel = '';
      state.selectedType = '';
      state.selectedSlot = null;
      state.finalCharge = 0;
      state.finalChargeLabel = '';
      if (els.input) {
        els.input.value = inputLabel || els.input.value || '';
      }
      if (els.suggestions) {
        els.suggestions.hidden = true;
        els.suggestions.innerHTML = '';
      }
      if (els.summary) els.summary.hidden = true;
      applyProperties();
      toggleReset();
      if (isEditingDeliverySelection) {
        clearSelectionCache();
      }
      /* Keep area selection clean; show validation only when Buy Now is pressed. */
      setMsg('Select a location suggestion or enter a 6-digit pincode.', '');
      syncDeliveryFlowVisibility();
      renderDateOptions();
    }
    function extractPostalCodeFromComponents(components) {
      var pin = '';
      (components || []).some(function (component) {
        var types = component.types || [];
        if (types.indexOf('postal_code') > -1) {
          pin = String(component.long_name || component.short_name || '').trim();
          return true;
        }
        return false;
      });
      return /^\d{6}$/.test(pin) ? pin : '';
    }
    function reverseGeocodePincode(location, done) {
      if (!location || !googleGeocoder) {
        done('');
        return;
      }
      googleGeocoder.geocode({ location: location }, function (results, status) {
        if (
          status !== google.maps.GeocoderStatus.OK ||
          !results ||
          !results.length
        ) {
          done('');
          return;
        }
        var pin = '';
        for (var i = 0; i < results.length; i++) {
          pin = extractPostalCodeFromComponents(results[i].address_components || []);
          if (pin) break;
        }
        done(pin);
      });
    }
    function forwardGeocodePincode(address, done) {
      if (!address || !googleGeocoder) {
        done('');
        return;
      }
      googleGeocoder.geocode({
        address: address,
        componentRestrictions: { country: 'IN' }
      }, function (results, status) {
        if (
          status !== google.maps.GeocoderStatus.OK ||
          !results ||
          !results.length
        ) {
          done('');
          return;
        }
        var pin = '';
        for (var i = 0; i < results.length; i++) {
          pin = extractPostalCodeFromComponents(results[i].address_components || []);
          if (pin) break;
        }
        done(pin);
      });
    }
    function resolveFallbackLocation(item) {
      var label = item.title || item.meta || '';
      var pin = extractPincode(item.title) ||
        extractPincode(item.meta) ||
        String(item.pincode || '').trim();
      var row = item.sheetMatch || findBestSheetRowForText(label);
      if (!pin && row && /^\d{6}$/.test(String(row.pincode || '').trim())) {
        pin = String(row.pincode).trim();
      }
      if (pin) {
        chooseMatchedLocation(findByPincode(pin) || row, label, pin);
      } else {
        getFallbackPincodeForLabel(label, function (fallbackPin, fallbackRow) {
          if (fallbackPin) {
            chooseMatchedLocation(
              findByPincode(fallbackPin) || fallbackRow,
              label,
              fallbackPin
            );
          } else {
            askForExactPincode(label);
          }
        });
      }
    }
    function resolveGooglePlace(item) {
      var fallbackLabel = item.title || item.meta || '';
      var suggestedPin = extractPincode(item.title) ||
        extractPincode(item.meta) ||
        String(item.pincode || '').trim();
      var suggestedRow = item.sheetMatch ||
        findBestSheetRowForText(item.title || fallbackLabel);
      if (!initGoogleServices() || !googlePlacesService) {
        var fallbackPin = suggestedPin ||
          (suggestedRow && String(suggestedRow.pincode || '').trim());
        if (fallbackPin) {
          chooseMatchedLocation(
            findByPincode(fallbackPin) || suggestedRow,
            item.title || fallbackLabel,
            fallbackPin
          );
        } else {
          askForExactPincode(fallbackLabel);
        }
        return;
      }
      googlePlacesService.getDetails({
        placeId: item.placeId,
        fields: ['address_components', 'formatted_address', 'name', 'geometry'],
        sessionToken: googleSessionToken || undefined
      }, function (place, status) {
        googleSessionToken = null;
        var label =
          (place && place.formatted_address) ||
          item.title ||
          item.meta ||
          '';
        if (
          status !== google.maps.places.PlacesServiceStatus.OK ||
          !place
        ) {
          var labelPin = extractPincode(label) || suggestedPin ||
            (suggestedRow && String(suggestedRow.pincode || '').trim());
          if (labelPin) {
            chooseMatchedLocation(
              findByPincode(labelPin) || suggestedRow,
              label,
              labelPin
            );
          } else {
            getFallbackPincodeForLabel(label, function (fallbackPin, fallbackRow) {
              if (fallbackPin) {
                chooseMatchedLocation(
                  findByPincode(fallbackPin) || fallbackRow,
                  label,
                  fallbackPin
                );
              } else {
                askForExactPincode(label);
              }
            });
          }
          return;
        }
        var pin = extractPostalCodeFromComponents(place.address_components || []);
        if (!pin) {
          pin = extractPincode(label);
        }
        if (pin) {
          chooseMatchedLocation(findByPincode(pin), label, pin);
          return;
        }
        var location =
          place.geometry && place.geometry.location
            ? place.geometry.location
            : null;
        reverseGeocodePincode(location, function (reversePin) {
          if (reversePin) {
            chooseMatchedLocation(findByPincode(reversePin), label, reversePin);
          } else if (suggestedRow && /^\d{6}$/.test(String(suggestedRow.pincode || '').trim())) {
            chooseMatchedLocation(
              suggestedRow,
              label,
              String(suggestedRow.pincode).trim()
            );
          } else {
            forwardGeocodePincode(label, function (addressPin) {
              if (addressPin) {
                chooseMatchedLocation(
                  findByPincode(addressPin),
                  label,
                  addressPin
                );
                return;
              }
              getFallbackPincodeForLabel(label, function (fallbackPin, fallbackRow) {
                if (fallbackPin) {
                  chooseMatchedLocation(
                    findByPincode(fallbackPin) || fallbackRow,
                    label,
                    fallbackPin
                  );
                } else {
                  askForExactPincode(label);
                }
              });
            });
          }
        });
      });
    }
    function handleRawInputLookup() {
      if (
        restoredSelectionLocked &&
        !isEditingDeliverySelection
      ) {
        if (els.input) els.input.value = getLocationLabel();
        renderSummary();
        root.classList.add('is-summary-mode');
        if (els.summary) els.summary.hidden = false;
        return;
      }

      var value = els.input ? els.input.value.trim() : '';
      if (!value) return;
      var pin = extractPincode(value);
      if (!pin) {
        setMsg('Select a location suggestion or enter a 6-digit pincode.', '');
        return;
      }
      var match = findByPincode(pin);
      if (match) {
        chooseMatchedLocation(
          match,
          buildReadableLocation([match.city, match.pincode]) || value
        );
      } else {
        chooseMatchedLocation(null, value, pin);
      }
    }
    function handleSubmit(e) {
      if (canProceedWithoutDeliverySelection()) {
        if (typeof window.__ogPrepareUnavailableNativeFlow === 'function') {
          window.__ogPrepareUnavailableNativeFlow();
        }
        return true;
      }
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
      if (isSubmitting) return false;
      if (!isReady()) {
        focusFirstMissingDeliveryStep();
        return false;
      }
      var payload = getProductFormPayload();
      if (!payload) {
        setMsg('Product variant not found. Please select product option again.', 'error');
        return false;
      }
      isSubmitting = true;
      setMsg('Adding product with delivery details...', '');
      postCartAdd(payload)
        .then(function () {
          saveSelection();
          return syncFeeItemInCart();
        })
        .then(function () {
          dispatchCartRefresh();
          openCartUi();
          setMsg('Added to cart with delivery details.', 'success');
        })
        .catch(function (err) {
          console.error('[OG Delivery] Add failed', err);
          setMsg('Could not add to cart. Please try again.', 'error');
        })
        .finally(function () {
          isSubmitting = false;
        });
      return false;
    }
    function bindEvents() {
      if (els.input) {
        els.input.addEventListener('input', function (e) {
          var value = els.input.value.trim();

          /*
           * Some theme/header scripts dispatch a delayed synthetic input
           * event with an empty value after the pincode has been resolved.
           * Keep the confirmed receiver location intact. A real customer can
           * still change it through the visible × reset button.
           */
          if (!value && state.matchedLocation && e && e.isTrusted === false) {
            els.input.value = getLocationLabel();
            toggleReset();
            return;
          }

          /*
           * GoKwik compatibility:
           * A restored selection is read-only until the customer explicitly
           * clicks Change/Reset. Ignore delayed autofill/input events entirely.
           */
          if (restoredSelectionLocked && !isEditingDeliverySelection) {
            clearTimeout(suggestionTimer);
            activeSuggestions = [];
            if (els.suggestions) {
              els.suggestions.hidden = true;
              els.suggestions.innerHTML = '';
            }
            if (els.input) els.input.value = getLocationLabel();
            setMsg('Location found! We deliver to this area.', 'success');
            renderSummary();
            applyProperties();
            toggleReset();
            root.setAttribute('data-og-restored-lock', 'true');
            root.classList.add('is-summary-mode');
            if (els.summary) els.summary.hidden = false;
            return;
          }

          toggleReset();
          state.matchedLocation = null;
          state.selectedDate = '';
          state.selectedDateLabel = '';
          state.selectedType = '';
          state.selectedSlot = null;
          if (els.summary) els.summary.hidden = true;
          syncDeliveryFlowVisibility();
          renderDateOptions();
          applyProperties();
          clearTimeout(suggestionTimer);

          if (value.length < 2) {
            renderSuggestions([]);
            setMsg('', '');
            return;
          }

          setMsg('Searching delivery locations...', '');
          suggestionTimer = setTimeout(function () {
            showCombinedSuggestions(value);
          }, 120);
        });
        els.input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleRawInputLookup();
          }
        });
        els.input.addEventListener('blur', function () {
          setTimeout(function () {
            if (els.suggestions) els.suggestions.hidden = true;
          }, 180);
        });
        els.input.addEventListener('focus', function () {
          if (activeSuggestions.length && els.suggestions) {
            els.suggestions.hidden = false;
          }
        });
      }
      if (els.suggestions) {
        els.suggestions.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
        els.suggestions.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-og-suggestion-index]');
          if (!btn) return;
          var item = activeSuggestions[Number(btn.getAttribute('data-og-suggestion-index'))];
          if (!item) return;
          if (item.source === 'sheet') {
            var match = item.pincode
              ? findByPincode(item.pincode)
              : findDefaultRowByCity(item.city || item.title) ||
                findByCity(item.city || item.title);
            if (match && !/^\d{6}$/.test(String(match.pincode || '').trim())) {
              match = null;
            }
            chooseMatchedLocation(
              match,
              item.title,
              item.pincode || (match && match.pincode) || ''
            );
          } else if (item.source === 'fallback') {
            resolveFallbackLocation(item);
          } else {
            resolveGooglePlace(item);
          }
        });
      }
      if (els.reset) {
        els.reset.addEventListener('click', function (e) {
          if (!e || e.isTrusted !== true) return;
          resetAll();
        });
      }
      if (els.dateOptions) {
        els.dateOptions.addEventListener('click', function (e) {
          if (!e || e.isTrusted !== true) return;
          var btn = e.target.closest('[data-og-date]');
          if (!btn || btn.disabled) return;
          restoredSelectionLocked = false;
          root.removeAttribute('data-og-restored-lock');
          isEditingDeliverySelection = true;
          selectDateValue(btn.getAttribute('data-og-date'));
        });
      }
      if (els.typeOptions) {
        els.typeOptions.addEventListener('click', function (e) {
          if (!e || e.isTrusted !== true) return;
          var slotBtn = e.target.closest('[data-og-inline-slot-index]');
          if (slotBtn) {
            var slotType = slotBtn.getAttribute('data-og-inline-slot-type');
            if (!slotType) return;

            var inlineSlots = getFilteredSlotsForType(slotType, state.selectedDate);
            var inlineSlot = inlineSlots[Number(slotBtn.getAttribute('data-og-inline-slot-index'))];
            if (!inlineSlot) return;

            state.selectedType = slotType;
            state.selectedSlot = inlineSlot;
            isEditingDeliverySelection = false;
            renderAll();
            saveSelection();

            setTimeout(function () {
              if (els.summary) {
                els.summary.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }, 120);
            return;
          }

          var btn = e.target.closest('[data-og-type]');
          if (!btn) return;

          var typeKey = btn.getAttribute('data-og-type');
          var slots = getFilteredSlotsForType(typeKey, state.selectedDate);
          if (!slots.length) return;

          if (slots.length === 1) {
            state.selectedType = typeKey;
            state.selectedSlot = slots[0];
            isEditingDeliverySelection = false;
            renderAll();
            saveSelection();

            setTimeout(function () {
              if (els.summary) {
                els.summary.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }, 100);
            return;
          }

          if (state.selectedType === typeKey) {

            state.selectedType = '';
            state.selectedSlot = null;
            renderAll();
            return;
          }

          state.selectedType = typeKey;
          state.selectedSlot = null;
          isEditingDeliverySelection = true;
          renderAll();
        });
      }

      if (els.slotOptions) {
        els.slotOptions.addEventListener('click', function (e) {
          if (!e || e.isTrusted !== true) return;
          var btn = e.target.closest('[data-og-slot-index]');
          if (!btn || !state.selectedType) return;

          var slots = getFilteredSlotsForType(state.selectedType, state.selectedDate);
          var slot = slots[Number(btn.getAttribute('data-og-slot-index'))];
          if (!slot) return;

          state.selectedSlot = slot;
          isEditingDeliverySelection = false;
          renderAll();
          saveSelection();

          setTimeout(function () {
            if (els.summary) {
              els.summary.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }, 120);
        });
      }
      if (els.modify) {
        els.modify.addEventListener('click', function (e) {
          if (!e || e.isTrusted !== true) return;
          restoredSelectionLocked = false;
          root.removeAttribute('data-og-restored-lock');
          isEditingDeliverySelection = true;
          renderAll();

          setTimeout(function () {
            if (els.dateOptions) {
              els.dateOptions.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }, 40);
        });
      }
      if (els.calendarOverlay) els.calendarOverlay.addEventListener('click', closeCalendar);
      if (els.calendarClose) els.calendarClose.addEventListener('click', closeCalendar);
      if (els.calendarPrev) {
        els.calendarPrev.addEventListener('click', function () {
          if (!state.calendarMonth) return;
          state.calendarMonth = new Date(
            state.calendarMonth.getFullYear(),
            state.calendarMonth.getMonth() - 1,
            1
          );
          renderCalendar();
        });
      }
      if (els.calendarNext) {
        els.calendarNext.addEventListener('click', function () {
          if (!state.calendarMonth) return;
          state.calendarMonth = new Date(
            state.calendarMonth.getFullYear(),
            state.calendarMonth.getMonth() + 1,
            1
          );
          renderCalendar();
        });
      }
      if (els.calendarDays) {
        els.calendarDays.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-og-calendar-date]');
          if (!btn || btn.disabled) return;
          selectDateValue(btn.getAttribute('data-og-calendar-date'));
        });
      }
      if (productForm) {
        productForm.addEventListener('submit', handleSubmit, true);
      }
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
        if (!root || !document.body.contains(root)) return;
        handleSubmit(e);
      }, true);
      document.addEventListener('click', function (e) {
  var btn = e.target.closest(
    'button[type="submit"], input[type="submit"], button[name="add"], .shopify-payment-button__button'
  );
  if (!btn) return;
  var form = btn.closest('form[action*="/cart/add"]');
  if (!form) return;
  if (!root || !document.body.contains(root)) return;
  if (!form.contains(root) && !root.contains(form) && form !== getCurrentProductForm()) {
    return;
  }
  if (canProceedWithoutDeliverySelection()) {
    if (typeof window.__ogPrepareUnavailableNativeFlow === 'function') {
      window.__ogPrepareUnavailableNativeFlow();
    }
    return;
  }
  if (!isReady()) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    focusFirstMissingDeliveryStep();
    return false;
  }
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }
  handleSubmit(e);
  return false;
}, true);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          markFeeLinesInDom();
          refreshActiveDeliverySelection();
          if (!isEditingDeliverySelection && readSelectionCache()) {
            restoreSelection();
          } else {
            renderAll();
          }
        }
      });
    }
    root.__ogSoftRestore = function () {
      bootSheetRows().then(function () {
        restoreSelection();
        markFeeLinesInDom();
      });
    };
    bootSheetRows().then(function () {
      bindEvents();
      if (!restoreSelection()) {
        renderAll();
      }
      toggleReset();
      markFeeLinesInDom();
      startSelectionRefreshMonitor();
    });
    scheduleFeeLineScan(120);
  }
  window.__initOgDeliveryCore = initOgDelivery;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOgDelivery);
  } else {
    initOgDelivery();
  }
document.addEventListener('click', function (e) {
  var btn = e.target.closest('button[type="submit"], .shopify-payment-button__button');
  if (!btn) return;
  var form = btn.closest('form[action*="/cart/add"]');
  if (!form) return;

  /*
   * Never replace/mutate the Buy Now button content during Rakhi bypass.
   * Some popup scripts resolve the clicked button from e.target later in the
   * same event. Replacing innerHTML here can detach e.target and kill the popup.
   */
  if (
    typeof window.__ogCanBypassDeliveryValidation === 'function' &&
    window.__ogCanBypassDeliveryValidation()
  ) {
    return;
  }

  var oldText = btn.innerHTML;
  btn.innerHTML = '⏳ Adding...';
  btn.style.opacity = '0.75';
  btn.style.pointerEvents = 'none';
  setTimeout(function () {
    btn.innerHTML = oldText;
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
  }, 2500);
});
  window.addEventListener('pageshow', initOgDelivery);
})();
(function () {
  'use strict';
  var checkoutInProgress = false;
  var savedMessageHtml = null;
  var savedMessageClass = null;
  var messageWasSuppressed = false;
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }
  function isProductFormButton(element) {
    if (!element || !element.closest) return false;
    return !!element.closest(
      'form[action*="/cart/add"]'
    );
  }
  function isInsideDeliveryWidget(element) {
    if (!element || !element.closest) return false;
    return !!element.closest(
      '#og-delivery-widget'
    );
  }
  function getClickedElement(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      'button,' +
      'a,' +
      'input[type="submit"],' +
      'input[type="button"]'
    );
  }
  function getCheckoutButton(target) {
    if (!target || !target.closest) return null;
    var checkoutButton = target.closest(
      'a[href*="/checkout"],' +
      'button[name="checkout"],' +
      'input[name="checkout"],' +
      '[name="checkout"],' +
      '.cart__checkout-button,' +
      '.cart-drawer__checkout,' +
      '.checkout-button,' +
      '.cart-checkout,' +
      '[data-cart-checkout],' +
      '[data-checkout-button],' +
      '[data-testid="Checkout-button"]'
    );
    if (checkoutButton) {
      if (isProductFormButton(checkoutButton)) return null;
      if (isInsideDeliveryWidget(checkoutButton)) return null;
      return checkoutButton;
    }
    var genericButton = getClickedElement(target);
    if (!genericButton) return null;
    if (isProductFormButton(genericButton)) return null;
    if (isInsideDeliveryWidget(genericButton)) return null;
    var text = normalizeText(
      genericButton.textContent ||
      genericButton.value ||
      ''
    );
    var href = normalizeText(
      genericButton.getAttribute('href') || ''
    );
    var name = normalizeText(
      genericButton.getAttribute('name') || ''
    );
    var ariaLabel = normalizeText(
      genericButton.getAttribute('aria-label') || ''
    );
    var title = normalizeText(
      genericButton.getAttribute('title') || ''
    );
    var isCheckout =
      href.indexOf('/checkout') > -1 ||
      name === 'checkout' ||
      text === 'checkout' ||
      text === 'check out' ||
      text.indexOf('checkout') > -1 ||
      text.indexOf('check out') > -1 ||
      ariaLabel.indexOf('checkout') > -1 ||
      ariaLabel.indexOf('check out') > -1 ||
      title.indexOf('checkout') > -1 ||
      title.indexOf('check out') > -1;
    return isCheckout ? genericButton : null;
  }
  function suppressUnavailableMessage() {
    var message = document.getElementById(
      'ogInlineMessage'
    );
    if (!message) return;
    var text = normalizeText(
      message.textContent || ''
    );
    if (
      text.indexOf('delivery is not available') === -1 &&
      text.indexOf('this product cannot be delivered') === -1
    ) {
      return;
    }
    if (!messageWasSuppressed) {
      savedMessageHtml = message.innerHTML;
      savedMessageClass = message.className;
    }
    messageWasSuppressed = true;
    message.innerHTML =
      '<span data-og-checkout-temp-message="true">' +
      'Proceeding to checkout...' +
      '</span>';
    message.className =
      'og-delivery__inline-message';
  }
  function restoreUnavailableMessage() {
    if (!messageWasSuppressed) return;
    var message = document.getElementById(
      'ogInlineMessage'
    );
    if (message) {
      if (savedMessageHtml !== null) {
        message.innerHTML = savedMessageHtml;
      }
      if (savedMessageClass !== null) {
        message.className = savedMessageClass;
      }
    }
    savedMessageHtml = null;
    savedMessageClass = null;
    messageWasSuppressed = false;
  }
  function prepareCheckout(event) {
    var checkoutButton = getCheckoutButton(
      event.target
    );
    if (!checkoutButton) return;
    suppressUnavailableMessage();
  }
  function showCheckoutLoading(button) {
    if (!button) return;
    if (
      !button.hasAttribute(
        'data-og-checkout-old-html'
      )
    ) {
      button.setAttribute(
        'data-og-checkout-old-html',
        button.innerHTML || ''
      );
    }
    if (
      !button.hasAttribute(
        'data-og-checkout-old-value'
      )
    ) {
      button.setAttribute(
        'data-og-checkout-old-value',
        button.value || ''
      );
    }
    if (button.tagName === 'INPUT') {
      button.value = 'Redirecting...';
    } else {
      button.innerHTML = '⏳ Redirecting...';
    }
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.75';
    button.setAttribute('aria-disabled', 'true');
  }
  function restoreCheckoutButton(button) {
    if (!button) return;
    var oldHtml = button.getAttribute(
      'data-og-checkout-old-html'
    );
    var oldValue = button.getAttribute(
      'data-og-checkout-old-value'
    );
    if (
      button.tagName === 'INPUT' &&
      oldValue !== null
    ) {
      button.value = oldValue;
    } else if (oldHtml !== null) {
      button.innerHTML = oldHtml;
    }
    button.style.pointerEvents = '';
    button.style.opacity = '';
    button.removeAttribute('aria-disabled');
    button.removeAttribute(
      'data-og-checkout-old-html'
    );
    button.removeAttribute(
      'data-og-checkout-old-value'
    );
  }
  function redirectToCheckout(event) {
    var checkoutButton = getCheckoutButton(
      event.target
    );
    if (!checkoutButton) return;
    event.preventDefault();
    event.stopPropagation();
    if (
      typeof event.stopImmediatePropagation ===
      'function'
    ) {
      event.stopImmediatePropagation();
    }
    if (checkoutInProgress) {
      return false;
    }
    checkoutInProgress = true;
    suppressUnavailableMessage();
    showCheckoutLoading(checkoutButton);
    window.location.replace('/checkout');
    setTimeout(function () {
      checkoutInProgress = false;
      restoreCheckoutButton(checkoutButton);
      restoreUnavailableMessage();
    }, 4000);
    return false;
  }
  window.addEventListener(
    'pointerdown',
    prepareCheckout,
    true
  );
  window.addEventListener(
    'click',
    redirectToCheckout,
    true
  );
  window.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }
      var checkoutButton = getCheckoutButton(
        event.target
      );
      if (!checkoutButton) return;
      suppressUnavailableMessage();
    },
    true
  );
  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (
        form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }
      var submitter = event.submitter || null;
      var checkoutButton = submitter
        ? getCheckoutButton(submitter)
        : null;
      var action = normalizeText(
        form.getAttribute('action') || ''
      );
      var isCheckoutSubmit =
        !!checkoutButton ||
        action.indexOf('/checkout') > -1;
      if (!isCheckoutSubmit) return;
      event.preventDefault();
      event.stopPropagation();
      if (
        typeof event.stopImmediatePropagation ===
        'function'
      ) {
        event.stopImmediatePropagation();
      }
      if (checkoutInProgress) return false;
      checkoutInProgress = true;
      suppressUnavailableMessage();
      if (submitter) {
        showCheckoutLoading(submitter);
      }
      window.location.replace('/checkout');
      return false;
    },
    true
  );
  window.addEventListener(
    'pageshow',
    function () {
      checkoutInProgress = false;
      restoreUnavailableMessage();
      document.querySelectorAll(
        '[data-og-checkout-old-html],' +
        '[data-og-checkout-old-value]'
      ).forEach(function (button) {
        restoreCheckoutButton(button);
      });
    }
  );
})();




















/* =========================================================
   OYE GIFTS - HIDE UNAVAILABLE MESSAGE ON RAKHI PRODUCTS ONLY
   Paste this at the VERY END of existing delivery code
========================================================= */

 (function () {
  'use strict';

  /* ONLY CHANGE THIS */
  var RAKHI_3_5_DAYS_MESSAGE = 'no';

  var CUSTOM_ID = 'ogRakhiUnavailableDeliveryMessage';


  function normalizeOgText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }


  function isRakhiProduct() {
    var productTitle = '';

    var titleNode = document.querySelector(
      'h1.product__title, h1.product-title, ' +
      '[data-product-title], .product-title h1'
    );

    if (titleNode) {
      productTitle = titleNode.textContent || '';
    }

    var source = [
      window.location.pathname || '',
      window.location.href || '',
      document.title || '',
      productTitle
    ].join(' ');

    return /rakhi/i.test(source);
  }


  function isUnavailableMessage(message) {
    if (!message) return false;

    var text = normalizeOgText(message.textContent);

    return (
      text.indexOf('this product cannot be delivered') > -1 ||
      text.indexOf('delivery is not available') > -1
    );
  }


  function removeCustomMessage() {
    var custom = document.getElementById(CUSTOM_ID);

    if (custom && custom.parentNode) {
      custom.parentNode.removeChild(custom);
    }
  }


   function showCustomMessage(message) {
  var custom = document.getElementById(CUSTOM_ID);

  if (!custom) {
    custom = document.createElement('div');

    custom.id = CUSTOM_ID;

    /*
     * Base delivery-message class only.
     * "is-unavailable" class intentionally NOT copied.
     */
    custom.className = 'og-delivery__inline-message';

    custom.innerHTML =
      'Delivery available · <strong>3–5 working days</strong>';

    custom.style.fontSize = '15px';
    custom.style.lineHeight = '1.5';

    message.parentNode.insertBefore(
      custom,
      message.nextSibling
    );
  }

  custom.innerHTML =
    'Delivery available · <strong>3–5 working days</strong>';

  custom.style.fontSize = '15px';
  custom.style.lineHeight = '1.5';
  custom.style.removeProperty('display');
}


  function restoreOriginalMessage(message) {
    if (!message) return;

    if (
      message.getAttribute(
        'data-og-rakhi-unavailable-hidden'
      ) === 'true'
    ) {
      message.style.removeProperty('display');

      message.removeAttribute(
        'data-og-rakhi-unavailable-hidden'
      );
    }
  }


  function syncRakhiMessage() {
    var message =
      document.getElementById('ogInlineMessage');

    if (!message) {
      removeCustomMessage();
      return;
    }


    /* Non-Rakhi = absolutely no change */
    if (!isRakhiProduct()) {
      removeCustomMessage();
      restoreOriginalMessage(message);
      return;
    }

    if (isUnavailableMessage(message)) {

      /*
       * Keep original unavailable text in DOM.
       * Only visually hide it because your existing
       * Rakhi Buy Now / bypass logic reads this state.
       */
      message.style.setProperty(
        'display',
        'none',
        'important'
      );

      message.setAttribute(
        'data-og-rakhi-unavailable-hidden',
        'true'
      );


      /* YES = show 3–5 working days */
      if (
        normalizeOgText(RAKHI_3_5_DAYS_MESSAGE) === 'yes'
      ) {
        showCustomMessage(message);
      }

      /* NO = show nothing */
      else {
        removeCustomMessage();
      }

      return;
    }


    /*
     * Location serviceable / searching / blank /
     * exact-pincode request / any normal state:
     *
     * No custom message.
     */
    removeCustomMessage();
    restoreOriginalMessage(message);
  }


  /* Watch your existing delivery message */
  var observedMessage = null;
  var messageObserver = null;


  function observeMessage() {
    var message =
      document.getElementById('ogInlineMessage');

    if (!message) return;

    if (message === observedMessage) {
      syncRakhiMessage();
      return;
    }

    if (messageObserver) {
      messageObserver.disconnect();
    }

    observedMessage = message;

    messageObserver = new MutationObserver(function () {
      setTimeout(syncRakhiMessage, 0);
    });

    messageObserver.observe(message, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    syncRakhiMessage();
  }


  function init() {
    observeMessage();

    if (document.body) {
      new MutationObserver(function () {
        var current =
          document.getElementById('ogInlineMessage');

        if (current && current !== observedMessage) {
          observeMessage();
        }
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();

/* =========================================================
   OG Location Suggestions UI — compact / lightweight
   ---------------------------------------------------------
   IMPORTANT: visual-only patch. It does NOT wrap, move or
   rebuild the location input, so existing IND / reset /
   product delivery layout remains untouched.
   ========================================================= */
(function () {
  'use strict';

  var STYLE_ID = 'og-location-suggestions-clean-v1';

  function addLocationUiStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '#og-delivery-widget #ogLocationSuggestions:not([hidden]){' +
        'background:#fff!important;' +
        'border:1px solid #e5e5e5!important;' +
        'border-radius:10px!important;' +
        'box-shadow:0 6px 18px rgba(0,0,0,.07)!important;' +
        'overflow-x:hidden!important;' +
        'overflow-y:auto!important;' +
        'max-height:330px!important;' +
        'overscroll-behavior:contain!important;' +
        'z-index:50!important;' +
      '}' +
      '#og-delivery-widget #ogLocationSuggestions[hidden]{display:none!important;}' +
      '#og-delivery-widget .og-delivery__suggestion{' +
        'appearance:none!important;-webkit-appearance:none!important;' +
        'display:grid!important;' +
        'grid-template-columns:30px minmax(0,1fr) auto!important;' +
        'align-items:center!important;' +
        'gap:10px!important;' +
        'width:100%!important;' +
        'min-height:58px!important;' +
        'margin:0!important;' +
        'padding:9px 12px!important;' +
        'border:0!important;' +
        'border-bottom:1px solid #eeeeee!important;' +
        'border-radius:0!important;' +
        'background:#fff!important;' +
        'color:#171717!important;' +
        'text-align:left!important;' +
        'cursor:pointer!important;' +
        'box-sizing:border-box!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion:first-child{' +
        'background:#f7f7f7!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion:last-child{' +
        'border-bottom:0!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion:hover,' +
      '#og-delivery-widget .og-delivery__suggestion:focus-visible{' +
        'background:#f5f5f5!important;outline:0!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion-icon{' +
        'display:flex!important;' +
        'align-items:center!important;' +
        'justify-content:center!important;' +
        'width:28px!important;height:28px!important;' +
        'color:#222!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion-icon svg{' +
        'display:block!important;width:24px!important;height:24px!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion-title{' +
        'display:block!important;' +
        'min-width:0!important;' +
        'color:#171717!important;' +
        'font-size:14px!important;' +
        'font-weight:500!important;' +
        'line-height:1.35!important;' +
        'white-space:normal!important;' +
        'overflow-wrap:anywhere!important;' +
      '}' +
      '#og-delivery-widget .og-delivery__suggestion-pin{' +
        'display:inline-flex!important;' +
        'align-items:center!important;' +
        'justify-content:center!important;' +
        'min-width:54px!important;' +
        'height:25px!important;' +
        'padding:0 7px!important;' +
        'border-radius:6px!important;' +
        'background:#f3f3f3!important;' +
        'color:#555!important;' +
        'font-size:11px!important;' +
        'font-weight:700!important;' +
        'line-height:1!important;' +
        'white-space:nowrap!important;' +
      '}' +
      '@media(max-width:749px){' +
        '#og-delivery-widget #ogLocationSuggestions:not([hidden]){' +
          'max-height:300px!important;border-radius:9px!important;' +
        '}' +
        '#og-delivery-widget .og-delivery__suggestion{' +
          'grid-template-columns:27px minmax(0,1fr) auto!important;' +
          'gap:8px!important;min-height:54px!important;padding:8px 10px!important;' +
        '}' +
        '#og-delivery-widget .og-delivery__suggestion-icon{' +
          'width:25px!important;height:25px!important;' +
        '}' +
        '#og-delivery-widget .og-delivery__suggestion-icon svg{' +
          'width:22px!important;height:22px!important;' +
        '}' +
        '#og-delivery-widget .og-delivery__suggestion-title{' +
          'font-size:13px!important;line-height:1.35!important;' +
        '}' +
        '#og-delivery-widget .og-delivery__suggestion-pin{' +
          'min-width:50px!important;height:23px!important;padding:0 6px!important;font-size:10.5px!important;' +
        '}' +
      '}';

    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addLocationUiStyles, { once: true });
  } else {
    addLocationUiStyles();
  }
})();
